<button
  *ngIf="userViewMode"
  pButton
  pRipple
  icon="pi pi-arrow-left"
  id="backToCards"
  label="Back to Cards"
  class="p-button-text back-btn"
  (click)="goBack()">
</button>

<div class="business-card-outer" data-testid="public-business-card" [ngClass]="{'preview-mode': previewMode}"
    [ngStyle]="card?.backgroundImage ? {
        '--bg-image': 'url(' + card?.backgroundImage + ')',
        '--logo': 'url(' + card?.logo + ')' || 'none',
        '--bg-opacity': card?.backgroundImage ? card?.backgroundImageOpacity : null,
        '--p-color': card?.primaryColor || 'none',
        '--s-color': card?.secondaryColor || 'none',
        '--p-contrast-color': getContrastColor(card?.primaryColor),
        '--s-contrast-color': getContrastColor(card?.secondaryColor)
        } : {
            '--logo': 'url(' + card?.logo + ')' || 'none',
            '--p-color': card?.primaryColor || 'none',
            '--s-color': card?.secondaryColor || 'none',
            '--p-contrast-color': getContrastColor(card?.primaryColor),
        '--s-contrast-color': getContrastColor(card?.secondaryColor)
        }">
  <ng-container *ngIf="loading; else notLoading">
    <!-- Loading state -->
    <div class="loading-container">
      <div class="loading-spinner"></div>
      <p>Loading business card...</p>
    </div>
  </ng-container>
  <ng-template #notLoading>
    <ng-container *ngIf="notFound; else showCard">
      <!-- Not found state -->
      <div class="not-found-container" data-testid="public-business-card-not-found">
        <h2>Business Card Not Found</h2>
        <p>
          The business card you're looking for doesn't exist or has been
          removed.
        </p>
      </div>
    </ng-container>
  </ng-template>
  <ng-template #showCard>
    <!-- Reusable templates -->

    <ng-template #imageLinkTpl let-link let-card="card">
        <a
            *ngIf="link.imageUrl"
            [href]="link.url"
            target="_blank"
            rel="noopener noreferrer"
            class="image-card"
            [style.backgroundImage]="'url(' + link.imageUrl + ')'">
            <div class="link-text" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">
            <ng-container *ngIf="link.name; else showUrl">
                {{ link.name }}
            </ng-container>
            <ng-template #showUrl>{{ link.url }}</ng-template>
            </div>
        </a>
    </ng-template>


    <ng-template #qrTpl let-card>
      <div *ngIf="card?.qrCode" class="qr-section">
        <img class="qr-code" [src]="card?.qrCode" alt="QR Code" />
      </div>
    </ng-template>

    <ng-template #poweredByTpl let-card let-extraClass="extraClass">
      <div
        *ngIf="card?.includePoweredByUrl !== false && isStarterProduct"
        class="powered-by"
        [ngClass]="extraClass"
        [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
      >
        <a
          *ngIf="card?.poweredByUrl"
          [href]="card?.poweredByUrl"
          target="_blank"
          >Powered by {{card.poweredBy}}</a
        >
        <span *ngIf="!card?.poweredByUrl">Powered by {{card.poweredBy}}</span>
      </div>
    </ng-template>

    <!-- Phone item: variants = 'default' | 'circle' | 'btn' | 'contactItem' | 'textIcon' | 'contactRow' | 'iconSplit' -->
    <ng-template #phoneItemTpl let-card let-phone="phone" let-variant="variant">
      <!-- default info-row style -->
      <div *ngIf="variant === 'default' && phone?.number" class="info-row">
        <i class="pi pi-phone" [style.color]="card?.secondaryColor"></i>
        <a [href]="'tel:' + phone.number">
          <span [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">
            Call {{ phone.number }}
            <small *ngIf="phone.type">({{ phone.type }})</small>
          </span>
        </a>
      </div>
      <!-- circle icon style (template1) -->
      <div *ngIf="variant === 'circle' && phone?.number" class="info-row">
        <span class="icon-circle">
          <i class="pi pi-phone" [style.color]="card?.secondaryColor"></i>
        </span>
        <a
          [href]="'tel:' + phone.number"
          [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
          class="phone"
        >
          Call {{ phone.number }}
          <span
            class="label"
            [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
            >({{ phone.type }})</span
          >
        </a>
      </div>
      <!-- btn style (template2) -->
      <a
        *ngIf="variant === 'btn' && phone?.number"
        [href]="'tel:' + phone.number"
        class="btn"
        [style.backgroundColor]="card?.secondaryColor"
        [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)"
        [style.borderColor]="getContrastColor(card?.secondaryColor)"
      >
        <span class="icon"><i class="pi pi-phone"></i></span> Call
        {{ phone.number }}
      </a>
      <!-- contact item block (template5) -->
      <div
        *ngIf="variant === 'contactItem' && phone?.number"
        class="contact-item"
        [style.backgroundColor]="card?.secondaryColor"
        [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)"
      >
        <i class="pi pi-phone" [style.color]="card?.buttonTextColor"></i>
        <a
          [href]="'tel:' + phone.number"
          [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)"
        >
          <span
            >Call {{ phone.number }} <em>({{ phone.type }})</em></span
          >
        </a>
      </div>
      <!-- text with icon inside anchor (template3) -->
      <a
        *ngIf="variant === 'textIcon' && phone?.number"
        [href]="'tel:' + phone.number"
        [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
      >
        <span class="icon"><i class="pi pi-phone"></i></span>
        Call {{ phone.number }}
        <span class="label">({{ phone.type }})</span>
      </a>
      <!-- split icon/text blocks (template6) -->
      <ng-container *ngIf="variant === 'iconSplit' && phone?.number">
        <div
          class="contact-icon"
          [style.backgroundColor]="card?.secondaryColor"
          [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"
        >
          <i class="pi pi-phone"></i>
        </div>
        <div
          class="contact-text"
          [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
        >
          <a
            [href]="'tel:' + phone.number"
            [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
          >
            Call {{ phone.number }}
            <span class="phone-type">{{ phone.type }}</span>
          </a>
        </div>
      </ng-container>
    </ng-template>

    <!-- Email item: variants = 'default' | 'circle' | 'btn' | 'contactItem' | 'textIcon' | 'contactRow' | 'iconSplit' -->
    <ng-template #emailItemTpl let-card let-variant="variant">
      <!-- default (non-link) -->
      <div *ngIf="variant === 'default' && card?.email" class="info-row">
        <i class="pi pi-envelope" [style.color]="card?.secondaryColor"></i>
        <span
          [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
          >{{card?.email}}</span
        >
      </div>
      <!-- circle variant (mailto link) -->
      <div *ngIf="variant === 'circle' && card?.email" class="info-row">
        <span class="icon-circle"
          ><i class="pi pi-envelope" [style.color]="card?.secondaryColor"></i
        ></span>
        <a
          [href]="'mailto:' + card?.email"
          [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
          >{{card?.email}}</a
        >
      </div>
      <!-- btn variant -->
      <a
        *ngIf="variant === 'btn' && card?.email"
        [href]="'mailto:' + card?.email"
        class="btn"
        [style.backgroundColor]="card?.secondaryColor"
        [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)"
        [style.borderColor]="getContrastColor(card?.secondaryColor)"
      >
        <span class="icon"><i class="pi pi-envelope"></i></span> Email
      </a>
      <!-- contactItem variant -->
      <div
        *ngIf="variant === 'contactItem' && card?.email"
        class="contact-item"
        [style.backgroundColor]="card?.secondaryColor"
        [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)"
      >
        <i class="pi pi-envelope" [style.color]="card?.buttonTextColor"></i>
        <a
          [href]="'mailto:' + card?.email"
          [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)"
        >
          <span>{{ card?.email }}</span>
        </a>
      </div>
      <!-- text with icon inside anchor (template3) -->
      <a
        *ngIf="variant === 'textIcon' && card?.email"
        [href]="'mailto:' + card?.email"
        [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
      >
        <span class="icon"><i class="pi pi-envelope"></i></span>
        {{ card?.email }}
      </a>
      <!-- split icon/text blocks (template6) -->
      <ng-container *ngIf="variant === 'iconSplit' && card?.email">
        <div
          class="contact-icon"
          [style.backgroundColor]="card?.secondaryColor"
          [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"
        >
          <i class="pi pi-envelope"></i>
        </div>
        <div
          class="contact-text"
          [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
        >
          <a
            [href]="'mailto:' + card?.email"
            [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
          >
            {{ card?.email }}
          </a>
        </div>
      </ng-container>
    </ng-template>

    <!-- Link item: variants = 'default' | 'circle' | 'btn' | 'contactItem' | 'textIcon' | 'iconSplit' -->
    <ng-template #linkItemTpl let-card let-link="link" let-variant="variant">
      <!-- default info-row -->
      <div *ngIf="variant === 'default' && link?.url" class="info-row">
        <i class="pi pi-globe" [style.color]="card?.secondaryColor"></i>
        <span>
          <a
            [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
            [href]="link.url"
            target="_blank"
            rel="noopener noreferrer"
            >{{link.name || link.url}}</a
          >
        </span>
      </div>
      <!-- circle variant -->
      <div *ngIf="variant === 'circle' && link?.url" class="info-row">
        <span class="icon-circle"
          ><i class="pi pi-globe" [style.color]="card?.secondaryColor"></i
        ></span>
        <span>
          <a
            [href]="link.url"
            target="_blank"
            rel="noopener noreferrer"
            [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
            >{{link.name || link.url}}</a
          >
        </span>
      </div>
      <!-- btn variant -->
      <a
        *ngIf="variant === 'btn' && link?.url"
        [href]="link.url"
        target="_blank"
        rel="noopener noreferrer"
        class="btn"
        [style.backgroundColor]="card?.secondaryColor"
        [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)"
        [style.borderColor]="getContrastColor(card?.secondaryColor)"
      >
        <span class="icon"><i class="pi pi-globe"></i></span> Website
      </a>
      <!-- contactItem variant -->
      <a
        *ngIf="variant === 'contactItem' && link?.url"
        [href]="link.url"
        target="_blank"
        class="no-underline contact-item text-center"
        [style.backgroundColor]="card?.secondaryColor"
        [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)"
      >
        <i class="pi pi-globe" [style.color]="card?.buttonTextColor"></i>
        {{ link.name || link.url }}
      </a>
      <!-- text with icon inside anchor (template3) -->
      <a
        *ngIf="variant === 'textIcon' && link?.url"
        [href]="link.url"
        target="_blank"
        rel="noopener noreferrer"
        [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
      >
        <span class="icon"><i class="pi pi-globe"></i></span>
        Website
      </a>
      <!-- split icon/text blocks (template6) -->
      <ng-container *ngIf="variant === 'iconSplit' && link?.url">
        <div
          class="contact-icon"
          [style.backgroundColor]="card?.secondaryColor"
          [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"
        >
          <i class="pi pi-globe"></i>
        </div>
        <div class="contact-text">
          <a
            [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
            [href]="link.url"
            target="_blank"
            >{{ link.name || link.url }}</a
          >
        </div>
      </ng-container>
    </ng-template>

    <!-- Social item: variants = 'text' | 'btn' | 'iconOnly' -->
    <ng-template
      #socialItemTpl
      let-card
      let-social="social"
      let-variant="variant"
      let-useCircleIcon="useCircleIcon"
    >
      <!-- text row with icon and label -->
      <div *ngIf="variant === 'text' && social?.url" class="info-row">
        <ng-container *ngIf="useCircleIcon; else plainIcon">
          <span class="icon-circle">
            <i
              class="pi pi-{{getSocialIcon(social.name.toLowerCase())}}"
              [style.color]="card?.secondaryColor"
            ></i>
          </span>
        </ng-container>
        <ng-template #plainIcon>
          <i
            class="pi pi-{{getSocialIcon(social.name.toLowerCase())}}"
            [style.color]="card?.secondaryColor"
          ></i>
        </ng-template>
        <span>
          <a
            [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
            [href]="social.url"
            target="_blank"
            rel="noopener noreferrer"
            >{{social.name}}</a
          >
        </span>
      </div>
      <!-- button variant -->
      <a
        *ngIf="variant === 'btn' && social?.url"
        [href]="social.url"
        target="_blank"
        rel="noopener noreferrer"
        class="btn"
        [style.backgroundColor]="card?.secondaryColor"
        [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)"
        [style.borderColor]="getContrastColor(card?.secondaryColor)"
      >
        <span class="icon"
          ><i class="pi pi-{{getSocialIcon(social.name.toLowerCase())}}"></i
        ></span>
        {{social.name}}
      </a>
      <!-- icon-only anchor (template3) -->
      <a
        *ngIf="variant === 'iconOnly' && social?.url"
        [href]="social.url"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i
          class="pi pi-{{ getSocialIcon(social.name.toLowerCase()) }}"
          [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"
        ></i>
      </a>
    </ng-template>

    <!-- Buttons variant -->
    <ng-template #contactActionsButtonTpl let-card>
      <button
        *ngIf="card?.vcf"
        [style.background]="card?.secondaryColor"
        [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)"
        class="contact-button"
        type="button"
        (click)="downloadVCard()"
      >
        <i class="pi pi-user-plus"></i> Save Contact
      </button>

        <div *ngIf="canAccessLeadCapture">
            <!-- Default Add Contact button (no custom form) -->
            <button
                *ngIf="!card?.customForm?.length"
                [style.background]="card?.secondaryColor"
                [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)"
                class="contact-button"
                type="button"
                (click)="showDialogContactModal(card?.id)">

                <i class="pi pi-user-plus"></i> Add Contact
            </button>

            <!-- Custom Form buttons -->
            <div *ngFor="let form of card?.customForm; let i = index">
                <button
                    [style.background]="card?.secondaryColor"
                    [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)"
                    class="contact-button"
                    type="button"
                    (click)="showCustomDialogContactModal(card?.id, form)">

                    <i class="pi pi-align-justify"></i>
                    {{ form?.name }}
                </button>
            </div>
        </div>

    </ng-template>

    <!-- Div variant (used by templates 3 and 4) -->
    <ng-template #contactActionsDivTpl let-card let-extraClass="extraClass">
        <!-- Save Contact -->
        <div
            *ngIf="card?.vcf"
            class="contact-button"
            [ngClass]="extraClass"
            [style.backgroundColor]="card?.secondaryColor"
            [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)"
            [style.borderColor]="getContrastColor(card?.secondaryColor)"
            (click)="downloadVCard()"
        >
            <i class="pi pi-user-plus"></i> Save Contact
        </div>

        <!-- Lead-capture actions -->
        <ng-container *ngIf="canAccessLeadCapture">
            <!-- Default Add Contact (no custom form) -->
            <div
                *ngIf="!card?.customForm?.length"
                class="contact-button"
                [ngClass]="extraClass"
                [style.backgroundColor]="card?.secondaryColor"
                [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)"
                [style.borderColor]="getContrastColor(card?.secondaryColor)"
                (click)="showDialogContactModal(card?.id)"
                >
                <i class="pi pi-user-plus"></i> Add Contact
            </div>

            <!-- Custom Form Buttons -->
            <div
                *ngFor="let form of card?.customForm"
                class="contact-button"
                [ngClass]="extraClass"
                [style.backgroundColor]="card?.secondaryColor"
                [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)"
                [style.borderColor]="getContrastColor(card?.secondaryColor)"
                (click)="showCustomDialogContactModal(card?.id, form)"
                >
                <i class="pi pi-align-justify"></i> {{ form?.name }}
            </div>
        </ng-container>
    </ng-template>

    <!-- Div variant with primary-colored icon (used by template 5) -->
    <ng-template #contactActionsDivIconTpl let-card let-extraClass="extraClass">
        <!-- Save Contact -->
        <div
            *ngIf="card?.vcf"
            class="contact-button"
            [ngClass]="extraClass"
            [style.backgroundColor]="card?.secondaryColor"
            [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)"
            [style.borderColor]="getContrastColor(card?.secondaryColor)"
            (click)="downloadVCard()">
                <i class="pi pi-user-plus" [style.color]="card?.buttonTextColor"></i>
                Save Contact
        </div>

        <!-- Lead-capture actions -->
        <ng-container *ngIf="canAccessLeadCapture">

            <!-- Default Add Contact (no custom form) -->
            <div
                *ngIf="!card?.customForm?.length"
                class="contact-button"
                [ngClass]="extraClass"
                [style.backgroundColor]="card?.secondaryColor"
                [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)"
                [style.borderColor]="getContrastColor(card?.secondaryColor)"
                (click)="showDialogContactModal(card?.id)"
                >
                <i class="pi pi-user-plus" [style.color]="card?.buttonTextColor"></i>
                Add Contact
            </div>

            <!-- Custom Form Buttons -->
            <div
                *ngFor="let form of card?.customForm"
                class="contact-button"
                [ngClass]="extraClass"
                [style.backgroundColor]="card?.secondaryColor"
                [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)"
                [style.borderColor]="getContrastColor(card?.secondaryColor)"
                (click)="showCustomDialogContactModal(card?.id, form)"
                >
                <i class="pi pi-align-justify" [style.color]="card?.buttonTextColor"></i>
                {{ form?.name }}
            </div>
        </ng-container>
    </ng-template>

    <!-- Anchor/btn variant (used by template 2) -->
    <ng-template #contactActionsAnchorTpl let-card>
        <!-- Save Contact -->
        <a
            *ngIf="card?.vcf"
            href="javascript:void(0)"
            class="btn"
            [style.backgroundColor]="card?.secondaryColor"
            [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)"
            [style.borderColor]="getContrastColor(card?.secondaryColor)"
            (click)="downloadVCard()"
        >
            <span class="icon"><i class="pi pi-user-plus"></i></span>
            Save Contact
        </a>

        <!-- Lead-capture actions -->
        <ng-container *ngIf="canAccessLeadCapture">
            <!-- Default Add Contact (no custom form) -->
            <a
            *ngIf="!card?.customForm?.length"
            href="javascript:void(0)"
            class="btn"
            [style.backgroundColor]="card?.secondaryColor"
            [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)"
            [style.borderColor]="getContrastColor(card?.secondaryColor)"
            (click)="showDialogContactModal(card?.id)"
            >
            <span class="icon"><i class="pi pi-user-plus"></i></span>
            Add Contact
            </a>

            <!-- Custom Form Actions -->
            <a
                *ngFor="let form of card?.customForm"
                href="javascript:void(0)"
                class="btn"
                [style.backgroundColor]="card?.secondaryColor"
                [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)"
                [style.borderColor]="getContrastColor(card?.secondaryColor)"
                (click)="showCustomDialogContactModal(card?.id, form)"
                >
                <span class="icon"><i class="pi pi-align-justify"></i></span>
                {{ form?.name }}
            </a>
        </ng-container>
    </ng-template>

    <!-- Default theme -->
    <div class="main-template default" *ngIf="!selectedTemplateRef">
      <div
        class="card"
        [style.backgroundColor]="card?.backgroundImage ? 'transparent' : card?.primaryColor"
        [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
      >
        <!-- Card found state -->
        <ng-container *ngIf="!loading && !notFound && card">
          <div
            class="card-header"
            [ngStyle]="{
               'background-color': card?.backgroundImage ? 'transparent' : card?.secondaryColor,
               'color': getContrastColor(card?.secondaryColor),
               'background-image': 'url(' + (card?.logo || '') + ')',
               'background-position': 'center',
               'background-size': 'cover',
               'background-repeat': 'no-repeat'
               }"
          >
            <div class="profile-container">
              <!-- Show photo if exists -->
              <div *ngIf="card?.photo">
                <img
                  [style.backgroundColor]="card?.primaryColor"
                  [style.borderColor]="card?.primaryColor"
                  class="profile-photo"
                  [src]="card?.photo"
                  [alt]="card?.firstName + ' ' + card?.lastName + ' Photo'"
                  (click)="showPreview(card?.photo)"
                />
              </div>
              <!-- Show name avatar if no photo -->
              <!-- (click)="showPreview('assets/layout/images/logo-dark.png')" -->
              <div
                *ngIf="!card?.photo"
                class="profile-photo name-avatar"
                [style.backgroundColor]="card?.secondaryColor"
                [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"
              >
                <div class="initials">
                  {{ getInitials(card?.firstName, card?.lastName) }}
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <h2 class="name" *ngIf="card?.firstName || card?.lastName">
              {{card?.firstName}} {{card?.lastName}}
            </h2>
            <h2 class="name" *ngIf="!card?.firstName && !card?.lastName">
              Name
            </h2>
            <div
              class="title"
              [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
            >
              {{card?.title || 'Professional'}}
            </div>
            <!-- <div
              *ngIf="card?.role"
              class="title"
              [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
            >
              {{card?.role || ''}}
            </div> -->
            <div *ngIf="card?.description" class="mt-0">
              {{card?.description}}
            </div>
            <div
              class="info-section"
              [style.borderColor]="card?.secondaryColor"
            >
              <!-- Organization if available -->
              <div *ngIf="card?.organization" class="info-row">
                <i
                  class="pi pi-building"
                  [style.color]="card?.secondaryColor"
                ></i>
                <span
                  [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
                  >{{card?.organization}}</span
                >
              </div>
              <!-- Phone numbers (reused) -->
              <ng-container *ngFor="let phone of card?.phone">
                <ng-container
                  *ngTemplateOutlet="phoneItemTpl; context: { $implicit: card, phone: phone, variant: 'default' }"
                ></ng-container>
              </ng-container>

              <!-- Email (reused) -->
              <ng-container
                *ngTemplateOutlet="emailItemTpl; context: { $implicit: card, variant: 'default' }"
              ></ng-container>
              <!-- Social Media (reused) -->
              <ng-container *ngFor="let social of card?.social">
                <ng-container *ngIf="social.url">
                  <ng-container
                    [ngTemplateOutlet]="socialItemTpl"
                    [ngTemplateOutletContext]="{ $implicit: card, social: social, variant: 'text' }"
                  ></ng-container>
                </ng-container>
              </ng-container>
            </div>

            <ng-container *ngIf="hasLinkUrl(card)">
                <h5 class="links-header" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">My Links</h5>
                <div class="my-links" *ngFor="let link of card?.links">
                    <!-- If there is an imageUrl -->
                    <ng-container *ngIf="link.imageUrl; else originalTemplate">
                        <ng-container
                            *ngTemplateOutlet="imageLinkTpl; context: { $implicit: link, card: card }">
                        </ng-container>
                    </ng-container>

                    <!-- Original layout if NO imageUrl -->
                    <ng-template #originalTemplate>
                        <div class="info-section">
                            <ng-container
                            *ngTemplateOutlet="linkItemTpl; context: { $implicit: card, link: link, variant: 'default' }"
                            ></ng-container>
                        </div>
                    </ng-template>
                </div>
            </ng-container>

            <gig-product-carousel
                *ngIf="card?.productCarousel && card?.productCarousel.length > 0"
                [dbCard]="card"
                [productCarousel]="card?.productCarousel">
            </gig-product-carousel>

            <!-- Contact actions (reused) -->
            <ng-container
              *ngTemplateOutlet="contactActionsButtonTpl; context: { $implicit: card }"
            ></ng-container>

            <!-- QR Code (reused) -->
            <ng-container
              *ngTemplateOutlet="qrTpl; context: { $implicit: card }"
            ></ng-container>

            <!-- Powered by (reused) -->
            <ng-container
              *ngTemplateOutlet="poweredByTpl; context: { $implicit: card }"
            ></ng-container>
          </div>
        </ng-container>
        <!-- Image preview modal overlay -->
        <div
          class="image-preview-overlay"
          *ngIf="previewImage"
          (click)="closePreview($event)"
        >
          <div class="preview-container" [ngClass]="{'fade-in': previewImage}">
            <button class="close-preview" (click)="closePreview($event)">
              ×
            </button>
            <img [src]="previewImage" alt="Preview" class="enlarged-image" />
          </div>
        </div>
      </div>
    </div>
    <!-- Dynamically load HTML -->
    <ng-container *ngIf="selectedTemplateRef">
      <ng-container
        *ngTemplateOutlet="selectedTemplateRef; context: { $implicit: card }"
      ></ng-container>
    </ng-container>
    <!-- Template definitions -->
    <ng-template #template1 let-card>
      <div class="main-template template1">
        <div
          class="card"
          [style.backgroundColor]="card?.backgroundImage ? 'transparent' : card?.primaryColor"
          [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
        >
          <!-- Header Image -->
          <div class="card-header">
            <img
              *ngIf="card?.photo"
              src="{{card?.photo}}"
              alt="Profile"
              class="profile-img"
            />
            <div
              class="initials"
              *ngIf="!card?.photo"
              [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
            >
              <h2>{{ getInitials(card?.firstName, card?.lastName) }}</h2>
            </div>

            <div *ngIf="!card?.backgroundImage">
                <!-- SVG curve separator -->
                <svg
                class="curve-separator"
                viewBox="0 0 1200 120"
                preserveAspectRatio="none"
                aria-hidden="true"
                >
                <path
                    d="M0,40 C300,120 900,0 1200,40 L1200,120 L0,120 Z"
                    [attr.fill]="card?.secondaryColor || '#f39c12'"
                ></path>
                </svg>
                <svg
                class="curve-separator-white"
                viewBox="0 0 1200 120"
                preserveAspectRatio="none"
                aria-hidden="true"
                >
                <path
                    d="M0,40 C300,120 900,0 1200,40 L1200,120 L0,120 Z"
                    [attr.fill]="card?.primaryColor || '#ffffff'"
                ></path>
                </svg>
            </div>

          </div>
          <!-- Card Body -->
          <div class="card-body" [ngStyle]="card?.backgroundImage ? {'margin-top.px': 15} : {}">
            <div class="logo">
              <img
                *ngIf="card?.logo"
                src="{{card?.logo || ''}}"
                alt="Logo"
                class="logo-img"
              />
              <div *ngIf="!card?.logo">&nbsp;</div>
            </div>
            <h2 class="name" *ngIf="card?.firstName || card?.lastName">
              {{ card?.firstName }} {{ card?.lastName }}
              <!-- <span class="label">(She/Her)</span> -->
            </h2>
            <h2 class="name" *ngIf="!card?.firstName && !card?.lastName">
              Name
            </h2>
            <p class="title">{{ card?.title || 'Professional' }}</p>
            <!-- <p class="company">{{ card?.role }}</p> -->
            <div *ngIf="card?.description" class="info-row">
              <span
                [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
                >{{card?.description}}</span
              >
            </div>
            <div *ngIf="card?.organization" class="info-row">
              <span class="icon-circle">
                <i
                  class="pi pi-building"
                  [style.color]="card?.secondaryColor"
                ></i>
              </span>
              <span
                [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
                >{{card?.organization}}</span
              >
            </div>
            <div class="contact" *ngFor="let phone of card?.phone">
              <ng-container
                *ngTemplateOutlet="phoneItemTpl; context: { $implicit: card, phone: phone, variant: 'circle' }"
              ></ng-container>
            </div>
            <ng-container
              *ngTemplateOutlet="emailItemTpl; context: { $implicit: card, variant: 'circle' }"
            ></ng-container>

            <div *ngFor="let social of card?.social">
              <ng-container *ngIf="social.url">
                <ng-container
                  [ngTemplateOutlet]="socialItemTpl"
                  [ngTemplateOutletContext]="{ $implicit: card, social: social, variant: 'text', useCircleIcon: true }"
                ></ng-container>
              </ng-container>
            </div>

            <ng-container *ngIf="hasLinkUrl(card)">
                <h5 class="links-header" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">My Links</h5>
                <div class="my-links" *ngFor="let link of card?.links">
                    <!-- If there is an imageUrl -->
                    <ng-container *ngIf="link.imageUrl; else originalTemplate">
                        <ng-container
                            *ngTemplateOutlet="imageLinkTpl; context: { $implicit: link, card: card }">
                        </ng-container>
                    </ng-container>

                    <!-- Original layout if NO imageUrl -->
                    <ng-template #originalTemplate>
                        <ng-container
                            *ngTemplateOutlet="linkItemTpl; context: { $implicit: card, link: link, variant: 'circle' }"
                        ></ng-container>
                    </ng-template>
                </div>
            </ng-container>

            <gig-product-carousel
                *ngIf="card?.productCarousel && card?.productCarousel.length > 0"
                [dbCard]="card"
                [productCarousel]="card?.productCarousel">
            </gig-product-carousel>

            <!-- Contact actions (reused) -->
            <ng-container
              *ngTemplateOutlet="contactActionsButtonTpl; context: { $implicit: card }"
            ></ng-container>

            <!-- QR Code (reused) -->
            <ng-container
              *ngTemplateOutlet="qrTpl; context: { $implicit: card }"
            ></ng-container>
            <!-- Powered by (reused) -->
            <ng-container
              *ngTemplateOutlet="poweredByTpl; context: { $implicit: card }"
            ></ng-container>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #template2 let-card>
      <div class="main-template template2">
        <div
          class="card"
          [style.backgroundColor]="card?.backgroundImage ? 'transparent' : card?.primaryColor"
          [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
        >
          <!-- Header -->
          <div
            class="header"
            [style.backgroundColor]="card?.backgroundImage ? 'transparent' : card?.secondaryColor"
            [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"
          >
            <img
              *ngIf="card?.logo"
              src="{{card?.logo}}"
              alt="Logo"
              class="logo"
            />
          </div>
          <!-- Profile + Info -->
          <div class="profile-section">
            <div class="profile-pic">
              <img
                [style.backgroundColor]="card?.backgroundImage ? 'transparent' : card?.primaryColor"
                *ngIf="card?.photo"
                src="{{card?.photo}}"
                alt="Profile Photo"
                [style.borderColor]="card?.primaryColor"
              />

              <div
                class="initials"
                *ngIf="!card?.photo"
                [style.backgroundColor]="card?.backgroundImage ? 'transparent' : card?.primaryColor"
              >
                <h2>{{ getInitials(card?.firstName, card?.lastName) }}</h2>
              </div>
            </div>
            <div
              class="info"
              [style.backgroundColor]="card?.backgroundImage ? 'transparent' : card?.secondaryColor"
              [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"
            >
              <div class="info-content">
                <h3 class="name" *ngIf="card?.firstName || card?.lastName">
                  {{ card?.firstName }} {{ card?.lastName }}
                </h3>
                <h3 class="name" *ngIf="!card?.firstName && !card?.lastName">
                  Name
                </h3>
                <div *ngIf="card?.organization">
                  <h3><i class="pi pi-building"></i> {{card?.organization}}</h3>
                </div>
                <div *ngIf="card?.description">
                  <h3>{{card?.description}}</h3>
                </div>
                <h3>
                  {{ card?.title || 'Professional'}} <br />
                  <!-- {{ card?.role || ''}} -->
                </h3>
              </div>
            </div>
          </div>
          <!-- Buttons -->
          <div class="buttons">
            <div class="contact" *ngFor="let phone of card?.phone">
              <ng-container
                *ngTemplateOutlet="phoneItemTpl; context: { $implicit: card, phone: phone, variant: 'btn' }"
              ></ng-container>
            </div>
            <div *ngIf="card?.email">
              <ng-container
                *ngTemplateOutlet="emailItemTpl; context: { $implicit: card, variant: 'btn' }"
              ></ng-container>
            </div>
            <!-- Links -->
            <!-- <div *ngFor="let link of card?.links">
              <ng-container
                [ngTemplateOutlet]="linkItemTpl"
                [ngTemplateOutletContext]="{ $implicit: card, link: link, variant: 'btn' }"
              ></ng-container>
            </div> -->
            <!-- Social -->
            <div *ngFor="let social of card?.social">
              <ng-container *ngIf="social.url">
                <ng-container
                  [ngTemplateOutlet]="socialItemTpl"
                  [ngTemplateOutletContext]="{ $implicit: card, social: social, variant: 'btn' }"
                ></ng-container>
              </ng-container>
            </div>

            <ng-container *ngIf="hasLinkUrl(card)">
                <h5 class="links-header" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">My Links</h5>
                <div class="my-links" *ngFor="let link of card?.links">
                    <!-- If there is an imageUrl -->
                    <ng-container *ngIf="link.imageUrl; else originalTemplate">
                        <ng-container
                            *ngTemplateOutlet="imageLinkTpl; context: { $implicit: link, card: card }">
                        </ng-container>
                    </ng-container>

                    <!-- Original layout if NO imageUrl -->
                    <ng-template #originalTemplate>
                        <ng-container
                            [ngTemplateOutlet]="linkItemTpl"
                            [ngTemplateOutletContext]="{ $implicit: card, link: link, variant: 'btn' }"
                        ></ng-container>
                    </ng-template>
                </div>
            </ng-container>

            <gig-product-carousel
                *ngIf="card?.productCarousel && card?.productCarousel.length > 0"
                [dbCard]="card"
                [productCarousel]="card?.productCarousel">
            </gig-product-carousel>

            <!-- Contact actions (reused) -->
            <ng-container
              *ngTemplateOutlet="contactActionsAnchorTpl; context: { $implicit: card }"
            ></ng-container>

            <!-- QR Code (reused) -->
            <ng-container
              *ngTemplateOutlet="qrTpl; context: { $implicit: card }"
            ></ng-container>

            <!-- Powered by (reused) -->
            <ng-container
              *ngTemplateOutlet="poweredByTpl; context: { $implicit: card }"
            ></ng-container>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #template3 let-card>
      <div class="main-template template3">
        <div
          class="card"
          [style.backgroundColor]="card?.backgroundImage ? 'transparent' : card?.primaryColor"
          [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
        >
          <!-- Header -->
          <div class="header"
            [style.backgroundColor]="card?.backgroundImage ? 'transparent' : card?.secondaryColor"
            >
            <img
              *ngIf="card?.logo"
              src="{{card?.logo}}"
              alt="Logo"
              class="header-logo"
            />
          </div>
          <!-- Profile Image (overlapping header) -->
          <div
            class="profile-image"
            [style.borderColor]="card?.secondaryColor"
            [style.backgroundColor]="card?.primaryColor"
          >
            <img *ngIf="card?.photo" src="{{card?.photo}}" alt="Profile" />
            <div
              class="initials"
              *ngIf="!card?.photo"
              [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
            >
              <h2>{{ getInitials(card?.firstName, card?.lastName) }}</h2>
            </div>
          </div>
          <!-- Name -->
          <h2 class="name" *ngIf="card?.firstName || card?.lastName">
            {{ card?.firstName }} {{ card?.lastName }}
          </h2>
          <h2 class="name" *ngIf="!card?.firstName && !card?.lastName">Name</h2>
          <!-- Position -->
          <p class="position">
            {{ card?.title || 'Professional' }}
            <!-- <br />{{ card?.role || '' }} -->
          </p>
          <p *ngIf="card?.description">
            {{card?.description}}
          </p>
          <!-- Contact Details -->
          <div class="contact-info">
            <div *ngFor="let phone of card?.phone">
              <ng-container
                *ngTemplateOutlet="phoneItemTpl; context: { $implicit: card, phone: phone, variant: 'textIcon' }"
              ></ng-container>
            </div>
            <ng-container
              *ngTemplateOutlet="emailItemTpl; context: { $implicit: card, variant: 'textIcon' }"
            ></ng-container>
          </div>
          <!-- Social Icons -->
          <div
            *ngIf="hasSocialUrl(card)"
            class="social-icons"
            [style.backgroundColor]="card?.secondaryColor"
            [style.borderColor]="getContrastColor(card?.secondaryColor)"
          >
            <div *ngFor="let social of card?.social">
              <ng-container *ngIf="social?.url">
                <ng-container
                  [ngTemplateOutlet]="socialItemTpl"
                  [ngTemplateOutletContext]="{ $implicit: card, social: social, variant: 'iconOnly' }"
                ></ng-container>
              </ng-container>
            </div>
          </div>
          <!-- Business Name -->
          <div
            *ngIf="card?.organization"
            class="business-name"
            [style.backgroundColor]="card?.secondaryColor"
            [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"
            [style.borderColor]="getContrastColor(card?.secondaryColor)"
          >
            {{ card?.organization }}
          </div>

          <ng-container *ngIf="hasLinkUrl(card)">
            <h5 class="links-header" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">My Links</h5>
            <div class="my-links" *ngFor="let link of card?.links">
                <!-- If there is an imageUrl -->
                <ng-container *ngIf="link.imageUrl; else originalTemplate">
                    <ng-container
                        *ngTemplateOutlet="imageLinkTpl; context: { $implicit: link, card: card }">
                    </ng-container>
                </ng-container>

                <!-- Original layout if NO imageUrl -->
                <ng-template #originalTemplate>
                    <ng-container
                    *ngTemplateOutlet="linkItemTpl; context: { $implicit: card, link: link, variant: 'textIcon' }"
                    ></ng-container>
                </ng-template>
            </div>
        </ng-container>

            <gig-product-carousel
                *ngIf="card?.productCarousel && card?.productCarousel.length > 0"
                [dbCard]="card"
                [productCarousel]="card?.productCarousel">
            </gig-product-carousel>

          <!-- Contact actions (reused) -->
          <ng-container
            *ngTemplateOutlet="contactActionsDivTpl; context: { $implicit: card }"
          ></ng-container>

          <!-- QR Code (reused) -->
          <ng-container
            *ngTemplateOutlet="qrTpl; context: { $implicit: card }"
          ></ng-container>

          <!-- Powered by (reused) -->
          <ng-container
            *ngTemplateOutlet="poweredByTpl; context: { $implicit: card }"
          ></ng-container>
        </div>
      </div>
    </ng-template>
    <ng-template #template4 let-card>
      <div class="main-template template4">
        <div
          class="card"
          [style.backgroundColor]="card?.backgroundImage ? 'transparent' : card?.primaryColor"
          [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
        >
          <!-- Header with gradient background -->
          <div
            class="header"
            [style.background]="card?.backgroundImage ? 'transparent' : generateGradient(card?.secondaryColor)"
            [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"
          >
            <div class="header-content">
              <img
                *ngIf="card?.logo"
                src="{{card?.logo}}"
                alt="Logo"
                class="header-logo"
              />
              <div *ngIf="!card?.logo">&nbsp;</div>
              <div class="header-text">
                <h2 *ngIf="card?.firstName || card?.lastName">
                  {{ card?.firstName }} {{ card?.lastName }}
                </h2>
                <h2 *ngIf="!card?.firstName && !card?.lastName">Name</h2>
              </div>
            </div>
          </div>
          <!-- Main Content -->
          <div class="content">
            <!-- Profile Image -->
            <div
              class="profile-image"
              [style.backgroundColor]="card?.primaryColor"
              [style.borderColor]="card?.digitalCardTextColor || card?.primaryColor"
            >
              <img *ngIf="card?.photo" src="{{card?.photo}}" alt="Profile" />
              <div
                class="initials"
                *ngIf="!card?.photo"
                [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
              >
                <h2>{{ getInitials(card?.firstName, card?.lastName) }}</h2>
              </div>
            </div>
            <!-- Position/Role with better styling -->
            <div
              class="position-role"
              [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
            >
              <p class="position">{{ card?.title || 'Professional' }}</p>
              <!-- <p *ngIf="card?.role" class="role">{{ card?.role }}</p> -->
            </div>
            <div class="description" *ngIf="card?.description">
              <span>{{card?.description}}</span>
            </div>
            <!-- Contact Details -->
            <div
              class="contact-info"
              [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
            >
              <div class="contact-item" *ngIf="card?.organization">
                <span class="icon" [style.color]="card?.secondaryColor"
                  ><i class="pi pi-building"></i
                ></span>
                <span class="text">{{ card?.organization }}</span>
              </div>
              <div
                [class.contact-item]="hasPhoneNumber(card)"
                *ngFor="let phone of card?.phone">
                <span
                  *ngIf="phone.number"
                  class="icon"
                  [style.color]="card?.secondaryColor"
                  ><i class="pi pi-phone"></i
                ></span>
                <span class="text" *ngIf="phone.number">
                  <a
                    [href]="'tel:' + phone.number"
                    [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
                  >
                    Call {{ phone.number }}
                    <span class="label">({{ phone.type }})</span>
                  </a>
                </span>
              </div>
              <div class="contact-item" *ngIf="card?.email">
                <span class="icon" [style.color]="card?.secondaryColor"
                  ><i class="pi pi-envelope"></i
                ></span>
                <a
                  href="mailto:{{card?.email}}"
                  [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
                >
                  <span class="text">{{ card?.email }}</span>
                </a>
              </div>


            </div>
            <!-- Social Icons -->
            <div class="social-icons">
              <div *ngFor="let social of card?.social">
                <div *ngIf="social.url">
                  <a
                    [style.backgroundColor]="card?.secondaryColor"
                    [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"
                    [style.box-shadow]="'0 3px 8px ' + hexToRgba(card?.secondaryColor, 0.3)"
                    [href]="social.url"
                    target="_blank"
                    rel="noopener noreferrer"
                    [title]="social.name"
                  >
                    <i
                      class="pi pi-{{ getSocialIcon(social.name.toLowerCase()) }}"
                    ></i>
                  </a>
                </div>
              </div>
            </div>

            <ng-container *ngIf="hasLinkUrl(card)">
                <h5 class="links-header" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">My Links</h5>
                <div class="my-links" *ngFor="let link of card?.links">
                    <!-- If there is an imageUrl -->
                    <ng-container *ngIf="link.imageUrl">
                        <ng-container
                            *ngTemplateOutlet="imageLinkTpl; context: { $implicit: link, card: card }">
                        </ng-container>
                    </ng-container>
                </div>
            </ng-container>

            <div
                class="contact-info"
                [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
                >
                <ng-container *ngFor="let link of card?.links">
                    <div class="contact-item" *ngIf="link.url && !link.imageUrl">
                    <a
                        [href]="link.url"
                        target="_blank"
                        rel="noopener noreferrer"
                        [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
                    >
                        <span class="icon" [style.color]="card?.secondaryColor">
                        <i class="pi pi-globe"></i>
                        </span>

                        <span class="text">
                        <ng-container
                            *ngIf="link.url.length > 50 && link.name; else showShortUrl"
                        >
                            {{ link.name }}
                        </ng-container>
                        <ng-template #showShortUrl>
                            {{ link.url }}
                        </ng-template>
                        </span>
                    </a>
                    </div>
                </ng-container>
            </div>

            <gig-product-carousel
                *ngIf="card?.productCarousel && card?.productCarousel.length > 0"
                [dbCard]="card"
                [productCarousel]="card?.productCarousel">
            </gig-product-carousel>

            <!-- Contact actions (reused) -->
            <ng-container
              *ngTemplateOutlet="contactActionsDivTpl; context: { $implicit: card }"
            ></ng-container>

            <!-- QR Code (reused) -->
            <ng-container
              *ngTemplateOutlet="qrTpl; context: { $implicit: card }"
            ></ng-container>
          </div>

          <!-- Powered by (reused) -->
          <ng-container
            *ngTemplateOutlet="poweredByTpl; context: { $implicit: card, extraClass: 'mt-0' }"
          ></ng-container>
        </div>
      </div>
    </ng-template>
    <ng-template #template5 let-card>
      <div class="main-template template5">
        <div
          class="card"
          [style.backgroundColor]="card?.backgroundImage ? 'transparent' : card?.primaryColor"
          [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
        >
          <!-- Gradient background header -->
          <div
            class="gradient-header"
            [style.background]="card?.backgroundImage ? 'transparent' : generateGradient(card?.secondaryColor)"
            [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"
          >
            <div class="header-content">
              <h2 *ngIf="card?.firstName  || card?.lastName">
                {{ card?.firstName }} {{ card?.lastName }}
              </h2>
              <h2 *ngIf="!card?.firstName  && !card?.lastName">Name</h2>
              <div class="title-role">
                <span>{{ card?.title || 'Professional' }}</span>
                <!-- <span *ngIf="card?.role"> • {{ card?.role }}</span> -->
              </div>
            </div>
          </div>
          <!-- Circular profile image -->
          <div class="profile-container">
            <div
              class="profile-image"
              [style.borderColor]="card?.primaryColor"
              [style.backgroundColor]="card?.primaryColor"
            >
              <img *ngIf="card?.photo" src="{{card?.photo}}" alt="Profile" />
              <div
                class="initials text-center"
                *ngIf="!card?.photo"
                [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
              >
                <h2>{{ getInitials(card?.firstName, card?.lastName) }}</h2>
              </div>
            </div>
          </div>
          <div
            class="description text-center mt-5 mb-0"
            *ngIf="card?.description"
          >
            <span>{{card?.description}}</span>
          </div>
          <!-- Contact info in card style -->
          <div class="contact-card">
            <div class="contact-grid">
              <!-- Organization -->
              <div
                *ngIf="card?.organization"
                class="contact-item"
                [style.backgroundColor]="card?.secondaryColor"
                [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)"
              >
                <i
                  class="pi pi-building"
                  [style.color]="card?.buttonTextColor"
                ></i>
                <span>{{ card?.organization }}</span>
              </div>
              <!-- Phone numbers -->
              <ng-container *ngFor="let phone of card?.phone">
                <ng-container
                  *ngTemplateOutlet="phoneItemTpl; context: { $implicit: card, phone: phone, variant: 'contactItem' }"
                ></ng-container>
              </ng-container>
              <!-- Email -->
              <ng-container *ngIf="card?.email">
                <ng-container
                  *ngTemplateOutlet="emailItemTpl; context: { $implicit: card, variant: 'contactItem' }"
                ></ng-container>
              </ng-container>

            <ng-container *ngIf="hasLinkUrl(card)">
                <h5 class="links-header" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">My Links</h5>
                <div class="my-links" *ngFor="let link of card?.links">
                    <!-- If there is an imageUrl -->
                    <ng-container *ngIf="link.imageUrl; else originalTemplate">
                        <ng-container
                            *ngTemplateOutlet="imageLinkTpl; context: { $implicit: link, card: card }">
                        </ng-container>
                    </ng-container>

                    <!-- Original layout if NO imageUrl -->
                    <ng-template #originalTemplate>
                        <ng-container
                        *ngTemplateOutlet="linkItemTpl; context: { $implicit: card, link: link, variant: 'contactItem' }"
                        ></ng-container>
                    </ng-template>
                </div>
            </ng-container>

            <gig-product-carousel
                *ngIf="card?.productCarousel && card?.productCarousel.length > 0"
                [dbCard]="card"
                [productCarousel]="card?.productCarousel">
            </gig-product-carousel>

              <!-- Contact actions (reused) -->
              <ng-container
                *ngTemplateOutlet="contactActionsDivIconTpl; context: { $implicit: card, extraClass: 'mt-0' }"
              ></ng-container>

              <!-- QR Code (reused) -->
              <ng-container
                *ngTemplateOutlet="qrTpl; context: { $implicit: card }"
              ></ng-container>
            </div>
          </div>
          <!-- Logo and social combined -->
          <div class="footer-section">
            <div class="logo" *ngIf="card?.logo">
              <img src="{{card?.logo}}" alt="Logo" />
            </div>
            <div class="social-icons">
              <div *ngFor="let social of card?.social">
                <a
                  *ngIf="social.url"
                  [href]="social.url"
                  target="_blank"
                  [style.backgroundColor]="card?.secondaryColor"
                  [style.color]="card?.primaryColor"
                >
                  <i
                    class="pi pi-{{ getSocialIcon(social.name.toLowerCase()) }}"
                  ></i>
                </a>
              </div>
            </div>
          </div>

          <!-- Powered by (reused) -->
          <ng-container
            *ngTemplateOutlet="poweredByTpl; context: { $implicit: card, extraClass: 'mt-0' }"
          ></ng-container>
        </div>
      </div>
    </ng-template>
    <ng-template #template6 let-card>
      <div class="main-template template6">
        <div
          class="card"
          [style.backgroundColor]="card?.backgroundImage ? 'transparent' : card?.primaryColor"
          [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
        >
          <!-- Modern asymmetrical header -->
          <div
            class="header-block"
            [style.background]="card?.backgroundImage ? 'transparent' : generateGradient(card?.secondaryColor)"
            [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"
          >
            <div class="header-content">
              <div class="logo" *ngIf="card?.logo">
                <img src="{{card?.logo}}" alt="Logo" />
              </div>
              <div class="header-text">
                <h2 *ngIf="card?.firstName || card?.lastName">
                  {{ card?.firstName }}
                  <strong
                    [style.color]="card?.digitalCardTextColor || card?.primaryColor"
                    >{{ card?.lastName }}</strong
                  >
                </h2>
                <h2 *ngIf="!card?.firstName && !card?.lastName">Name</h2>
                <div class="title-role">
                  <span>{{ card?.title || 'Professional' }}</span>
                  <!-- <span *ngIf="card?.role">| {{ card?.role }}</span> -->
                </div>
              </div>
            </div>
          </div>
          <!-- Profile image with geometric shape -->
          <div class="profile-container">
            <div
              class="profile-shape"
              [style.backgroundColor]="card?.secondaryColor"
            >
              <div class="profile-image">
                <img *ngIf="card?.photo" src="{{card?.photo}}" alt="Profile" />
                <div
                  class="initials"
                  *ngIf="!card?.photo"
                  [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
                >
                  <h2>{{ getInitials(card?.firstName, card?.lastName) }}</h2>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="card?.description" class="text-center mt-5 mb-0">
            <span>{{card?.description}}</span>
          </div>
          <!-- Minimalist contact list -->
          <div class="contact-section">
            <div *ngIf="card?.organization" class="contact-item">
              <div
                class="contact-icon"
                [style.backgroundColor]="card?.secondaryColor"
                [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"
              >
                <i class="pi pi-building"></i>
              </div>
              <div
                class="contact-text"
                [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
              >
                {{ card?.organization }}
              </div>
            </div>
            <div *ngFor="let phone of card?.phone" class="contact-item">
              <div
                *ngIf="phone.number"
                class="contact-icon"
                [style.backgroundColor]="card?.secondaryColor"
                [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"
              >
                <i class="pi pi-phone"></i>
              </div>
              <div
                *ngIf="phone.number"
                class="contact-text"
                [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
              >
                <a
                  [href]="'tel:' + phone.number"
                  [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
                >
                  Call {{ phone.number }}
                  <span class="phone-type">{{ phone.type }}</span>
                </a>
              </div>
            </div>
            <div *ngIf="card?.email" class="contact-item">
              <div
                class="contact-icon"
                [style.backgroundColor]="card?.secondaryColor"
                [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"
              >
                <i class="pi pi-envelope"></i>
              </div>
              <div
                class="contact-text"
                [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
              >
                <a
                  href="mailto:{{card?.email}}"
                  [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
                >
                  {{ card?.email }}
                </a>
              </div>
            </div>
          </div>

          <!-- Floating social media bar - Updated Version -->
          <div class="social-bar">
            <div *ngFor="let social of card?.social" class="social-item">
              <a
                *ngIf="social.url"
                [style.backgroundColor]="card?.secondaryColor"
                [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"
                [href]="social.url"
                target="_blank"
                [title]="social.name"
              >
                <i
                  class="pi pi-{{ getSocialIcon(social.name.toLowerCase()) }}"
                ></i>
                <span
                  class="social-tooltip"
                  [style.backgroundColor]="card?.secondaryColor"
                  [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"
                  >{{ social.name }}</span
                >
              </a>
            </div>
          </div>

        <ng-container *ngIf="hasLinkUrl(card)">
            <h5 class="links-header" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">My Links</h5>
            <div class="my-links" *ngFor="let link of card?.links">
                <!-- If there is an imageUrl -->
                <ng-container *ngIf="link.imageUrl; else originalTemplate">
                    <ng-container
                        *ngTemplateOutlet="imageLinkTpl; context: { $implicit: link, card: card }">
                    </ng-container>
                </ng-container>

                <!-- Original layout if NO imageUrl -->
                <ng-template #originalTemplate>
                    <div class="contact-item" *ngIf="link?.url">
                        <a
                            [href]="link.url"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="contact-link"
                        >
                            <div
                                class="contact-icon"
                                [style.backgroundColor]="card?.secondaryColor"
                                [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"
                            >
                                <i class="pi pi-globe"></i>
                            </div>
                        </a>

                        <div class="contact-text">
                            <a
                                [href]="link.url"
                                target="_blank"
                                rel="noopener noreferrer"
                                [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
                            >
                                {{ link.name || link.url }}
                            </a>
                        </div>
                    </div>
                </ng-template>
            </div>
        </ng-container>

          <gig-product-carousel
                *ngIf="card?.productCarousel && card?.productCarousel.length > 0"
                [dbCard]="card"
                [productCarousel]="card?.productCarousel">
            </gig-product-carousel>

          <!-- Contact actions (reused) -->
          <ng-container
            *ngTemplateOutlet="contactActionsButtonTpl; context: { $implicit: card }"
          ></ng-container>

          <!-- QR Code (reused) -->
          <ng-container
            *ngTemplateOutlet="qrTpl; context: { $implicit: card }"
          ></ng-container>

          <!-- Powered by (reused) -->
          <ng-container
            *ngTemplateOutlet="poweredByTpl; context: { $implicit: card }"
          ></ng-container>
        </div>
      </div>
    </ng-template>
    <ng-template #template7 let-card>
      <div class="main-template template7">
        <div class="card"
          [style.backgroundColor]="card?.backgroundImage ? 'transparent' : card?.primaryColor"
          [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
        >

        <div class="logo">
          <img
            *ngIf="card?.logo"
            src="{{card?.logo || ''}}"
            alt="Logo"
            class="logo-img"
          />
          <div *ngIf="!card?.logo">&nbsp;</div>
        </div>

          <!-- Horizontal line behind profile -->
          <hr class="profile-line" [style.backgroundColor]="getContrastColor(card?.primaryColor)" />

          <div class="profile-pic">
            <img *ngIf="card?.photo" src="{{card?.photo}}" alt="Profile" />
            <div *ngIf="!card?.photo"  class="initials" [style.backgroundColor]="card?.secondaryColor">
              <h2 [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">{{ getInitials(card?.firstName, card?.lastName) }}</h2>
            </div>
          </div>

          <div class="name" [style.background]="card?.secondaryColor">
            <div *ngIf="card?.firstName || card?.lastName">
              {{ card?.firstName }} {{ card?.lastName }}
            </div>
            <div *ngIf="!card?.firstName && !card?.lastName">
              Name
            </div>
          </div>

          <div
            class="position"
            [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
          >
            {{card?.title || 'Professional'}}
          </div>

          <!-- <span *ngIf="card?.role">{{ card?.role }}</span> -->

          <div class="description" *ngIf="card?.description">
            <span>{{card?.description}}</span>
          </div>

          <div class="contact">
            <div *ngIf="card?.organization" class="info-row">
              <span class="icon-circle">
                <i class="pi pi-building" [style.color]="card?.secondaryColor"></i>
              </span>
              <span
                [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
                >{{card?.organization}}</span
              >
            </div>
            <div *ngFor="let phone of card?.phone">
              <ng-container
                *ngTemplateOutlet="phoneItemTpl; context: { $implicit: card, phone: phone, variant: 'circle' }"
              ></ng-container>
            </div>

            <ng-container
              *ngTemplateOutlet="emailItemTpl; context: { $implicit: card, variant: 'circle' }"
            ></ng-container>

            <!-- <div *ngFor="let link of card?.links">
              <ng-container
                *ngTemplateOutlet="linkItemTpl; context: { $implicit: card, link: link, variant: 'circle' }"
              ></ng-container>
            </div> -->

            <div *ngFor="let social of card?.social">
              <ng-container *ngIf="social.url">
                <ng-container
                  [ngTemplateOutlet]="socialItemTpl"
                  [ngTemplateOutletContext]="{ $implicit: card, social: social, variant: 'text', useCircleIcon: true }"
                ></ng-container>
              </ng-container>
            </div>
          </div>

          <ng-container *ngIf="hasLinkUrl(card)">
            <h5 class="links-header" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">My Links</h5>
            <div class="my-links" *ngFor="let link of card?.links">
                <!-- If there is an imageUrl -->
                <ng-container *ngIf="link.imageUrl; else originalTemplate">
                    <ng-container
                        *ngTemplateOutlet="imageLinkTpl; context: { $implicit: link, card: card }">
                    </ng-container>
                </ng-container>

                <!-- Original layout if NO imageUrl -->
                <ng-template #originalTemplate>
                    <ng-container
                        *ngTemplateOutlet="linkItemTpl; context: { $implicit: card, link: link, variant: 'circle' }"
                    ></ng-container>
                </ng-template>
            </div>
        </ng-container>

          <gig-product-carousel
                *ngIf="card?.productCarousel && card?.productCarousel.length > 0"
                [dbCard]="card"
                [productCarousel]="card?.productCarousel">
            </gig-product-carousel>

          <!-- Contact actions (reused) -->
          <ng-container
            *ngTemplateOutlet="contactActionsButtonTpl; context: { $implicit: card }"
          ></ng-container>

          <!-- QR Code (reused) -->
          <ng-container
            *ngTemplateOutlet="qrTpl; context: { $implicit: card }"
          ></ng-container>
          <!-- Powered by (reused) -->
          <ng-container
            *ngTemplateOutlet="poweredByTpl; context: { $implicit: card }"
          ></ng-container>

        </div>
      </div>
    </ng-template>
    <ng-template #template8 let-card>
      <div class="main-template template8">
        <div class="card"
          [style.backgroundColor]="card?.backgroundImage ? 'transparent' : card?.primaryColor"
          [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">
          <div class="logo">
            <img *ngIf="card?.logo" [src]="card?.logo" alt="Logo" class="logo-img" />
            <div *ngIf="!card?.logo">&nbsp;</div>

          </div>

          <div class="organization" *ngIf="card?.organization">
            <h3>{{card?.organization}}</h3>
          </div>

          <div class="profile-pic">
            <img *ngIf="card?.photo" [src]="card?.photo" alt="Profile" />
            <div *ngIf="!card?.photo" class="initials" [style.backgroundColor]="card?.secondaryColor">
              <h2 [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)">
                {{ getInitials(card?.firstName, card?.lastName) }}
              </h2>
            </div>
          </div>
          <div class="info">
            <div class="name"
              [style.backgroundColor]="card?.secondaryColor"
              [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"
              >{{ card?.firstName }} {{ card?.lastName }}</div>
            <div class="title"
              [style.backgroundColor]="card?.secondaryColor"
              [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"
              >{{ card?.title || 'Professional' }}
            </div>

            <!-- <div class="role"
              *ngIf="card?.role"
              [style.backgroundColor]="card?.secondaryColor"
              [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"
              >{{ card?.role }}
            </div> -->

            <div class="description"
              *ngIf="card?.description"
              [style.backgroundColor]="card?.primaryColored"
              [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColored)"
              >{{ card?.description }}
            </div>
          </div>

          <ng-container *ngIf="hasLinkUrl(card)">
            <h5 class="links-header" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">My Links</h5>
            <div class="my-links" *ngFor="let link of card?.links">
                <!-- If there is an imageUrl -->
                <ng-container *ngIf="link.imageUrl; else originalTemplate">
                    <ng-container
                        *ngTemplateOutlet="imageLinkTpl; context: { $implicit: link, card: card }">
                    </ng-container>
                </ng-container>

                <!-- Original layout if NO imageUrl -->
                <ng-template #originalTemplate>
                    <p class="mb-2">
                        <a
                            *ngIf="link?.url"
                            target="_blank"
                            [href]="link?.url"
                            [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"
                            >
                            <span class="icon"
                                [style.backgroundColor]="card?.primaryColor"
                                [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"
                                ><i class="pi pi-globe"></i>
                            </span>

                            {{link?.name || link?.url}}
                        </a>
                    </p>
                </ng-template>
            </div>
        </ng-container>

          <gig-product-carousel
            *ngIf="card?.productCarousel && card?.productCarousel.length > 0"
            [dbCard]="card"
            [productCarousel]="card?.productCarousel">
        </gig-product-carousel>

          <div
            class="contact-section"
            [style.backgroundColor]="card?.secondaryColor"
            [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"
          >
            <div class="contact-row">
                <div class="contact-item mt-3">
                    <span class="icon"
                        *ngIf="hasPhoneNumber(card)"
                        [style.backgroundColor]="card?.primaryColor"
                        [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
                        ><i class="pi pi-phone"></i></span>
                    <div class="label" *ngIf="hasPhoneNumber(card)">Phone</div>
                    <div *ngFor="let phone of card?.phone">
                    <div class="value">
                        <a
                            *ngIf="phone?.number"
                            [href]="'tel:' + phone?.number"
                            [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"
                        >
                            {{ phone?.number }}
                        </a>
                    </div>
                </div>

                <div class="contact-item mt-3" *ngIf="card?.email">
                    <span class="icon"
                    [style.backgroundColor]="card?.primaryColor"
                    [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
                    ><i class="pi pi-envelope"></i></span>
                    <div class="label">Email</div>
                    <div class="value">
                    <a
                        [href]="'mailto:' + card?.email"
                        [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"
                        >{{card?.email}}</a
                    >
                    </div>
                </div>

                <!-- <div class="contact-item mt-3">
                  <span class="icon"
                    *ngIf="hasLinkUrl(card)"
                    [style.backgroundColor]="card?.primaryColor"
                    [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
                    ><i class="pi pi-globe"></i></span>
                  <div class="label" *ngIf="hasLinkUrl(card)">Website</div>
                  <div *ngFor="let link of card?.links">
                    <div class="value">
                      <a
                        *ngIf="link?.url"
                        target="_blank"
                        [href]="link?.url"
                        [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"
                      >
                        {{link?.name || link?.url}}
                      </a>
                    </div>
                  </div>
                </div> -->

              </div>

              <div class="contact-item">

                <button
                  *ngIf="card?.vcf"
                  [style.background]="card?.primaryColor"
                  [style.color]="card?.buttonTextColor || getContrastColor(card?.primaryColor)"
                  class="contact-button"
                  type="button"
                  (click)="downloadVCard()"
                >
                  <i class="pi pi-user-plus"></i> Save Contact
                </button>

                <!-- Lead-capture actions -->
                <ng-container *ngIf="canAccessLeadCapture">

                    <!-- Default Add Contact (no custom form) -->
                    <button
                        *ngIf="!card?.customForm?.length"
                        [style.background]="card?.primaryColor"
                        [style.color]="card?.buttonTextColor || getContrastColor(card?.primaryColor)"
                        class="contact-button"
                        type="button"
                        (click)="showDialogContactModal(card?.id)"
                    >
                        <i class="pi pi-user-plus"></i> Add Contact
                    </button>

                    <!-- Custom Form Buttons -->
                    <button
                        *ngFor="let form of card?.customForm"
                        [style.background]="card?.primaryColor"
                        [style.color]="card?.buttonTextColor || getContrastColor(card?.primaryColor)"
                        class="contact-button"
                        type="button"
                        (click)="showCustomDialogContactModal(card?.id, form)"
                    >
                        <i class="pi pi-align-justify"></i> {{ form?.name }}
                    </button>

                </ng-container>


                <!-- QR Code (reused) -->
                <ng-container
                  *ngTemplateOutlet="qrTpl; context: { $implicit: card }"
                >
                </ng-container>
              </div>
            </div>
          </div>
          <div class="connect-section"
            *ngIf="hasSocialUrl(card)"
            [style.backgroundColor]="card?.secondaryColor"
            [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)">
            <div class="connect-label">Connect with me</div>
            <div class="social-row">
              <div *ngFor="let social of card?.social">
                <ng-container *ngIf="social?.url">
                  <ng-container
                    [ngTemplateOutlet]="socialItemTpl"
                    [ngTemplateOutletContext]="{ $implicit: card, social: social, variant: 'iconOnly' }"
                  ></ng-container>
                </ng-container>
              </div>
            </div>
          </div>
          <!-- Powered by (reused) -->
          <ng-container
            *ngTemplateOutlet="poweredByTpl; context: { $implicit: card }"
          ></ng-container>
        </div>
      </div>
    </ng-template>
    <ng-template #template9 let-card>
      <div class="main-template template9">
        <div class="card"
          [style.backgroundColor]="card?.backgroundImage ? 'transparent' : card?.primaryColor"
          [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">
          <div class="ceo-content"
            [style.backgroundColor]="card?.backgroundImage ? 'transparent' : card?.primaryColor"
            [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">
              <div class="hero-top-sec"
                [ngStyle]="!card?.logo ? { height: '50px' } : { height: '300px' }">

                <img *ngIf="card?.logo" [src]="card?.logo" alt="banner-img" class="banner-img">

                <svg
                    [ngStyle]="{
                        'visibility': card?.backgroundImage ? 'hidden' : 'visible'
                    }"
                  viewBox="0 0 1920 200"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="position: absolute; margin-top: -40px; left: 0; width: 100%; height: auto;"
                >
                  <path
                    d="M174.5 56.577C80.1001 48.977 19.3334 88.0771 0 109.077V200C0 200 1280.17 199.911 1920 200V20C1910 49.5775 1769.02 159.577 1575 159.577C1339 159.577 1210.5 58.5772 1040.5 58.5772C907 58.5772 812.454 159.907 607 155.577C393.5 151.078 358 71.3503 174.5 56.577Z"
                    [attr.fill]="card?.primaryColor || '#ffffff'"
                  />
                </svg>
                <svg
                    [ngStyle]="{
                        'visibility': card?.backgroundImage ? 'hidden' : 'visible'
                    }"
                  viewBox="0 0 1920 200"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="position: absolute; margin-top: -35px; left: 0; width: 100%; height: auto;"
                >
                  <path
                    d="M174.5 56.577C80.1001 48.977 19.3334 88.0771 0 109.077V200C0 200 1280.17 199.911 1920 200V20C1910 49.5775 1769.02 159.577 1575 159.577C1339 159.577 1210.5 58.5772 1040.5 58.5772C907 58.5772 812.454 159.907 607 155.577C393.5 151.078 358 71.3503 174.5 56.577Z"
                    [attr.fill]="card?.primaryColor || '#ffffff'"
                  />
                </svg>
              </div>
              <div class="hero-bottom-sec">
                <div class="team-media" [style.--team-media-color]="card?.secondaryColor">
                  <img *ngIf="card?.photo" [src]="card?.photo" alt="client-img" class="client-img">
                  <h2 *ngIf="!card?.photo" class="client-img">
                    {{ getInitials(card?.firstName, card?.lastName) }}
                  </h2>
                </div>

                <div>
                  <h1 class="client-name mt-3" *ngIf="card?.firstName || card?.lastName" [style.color]="card?.digitalCardTextColor || card?.secondaryColor">
                    {{ card?.firstName }} {{ card?.lastName }}
                  </h1>
                  <h1 class="client-name mt-3" *ngIf="!card?.firstName && !card?.lastName" [style.color]="card?.digitalCardTextColor || card?.secondaryColor">
                    Name
                  </h1>
                  <p class="client-title mb-2" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">
                    {{ card?.title || 'Professional' }}
                  </p>
                </div>
              </div>
              <div class="social-media-sec container">

                <div class="social-icon-content" *ngIf="hasSocialUrl(card)">
                    <div *ngFor="let social of card?.social">
                        <div *ngIf="social.url">
                            <a
                            [href]="social.url"
                            target="_blank"
                            rel="noopener noreferrer"
                            [title]="social.name"
                            >
                            <div class="social-icon-content-wrap"
                                [style.borderColor]="card?.secondaryColor"
                                [style.background]="card?.secondaryColor"
                                [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"
                                >
                                <span class="icon"><i class="pi pi-{{ getSocialIcon(social.name.toLowerCase()) }}"></i></span>
                            </div>
                            </a>
                        </div>
                    </div>
                </div>

                <div class="social-icon-para mt-2">
                  <div class="top-title" *ngIf="card?.organization" [style.color]="card?.digitalCardTextColor || card?.secondaryColor">
                    <h2>{{card?.organization}}</h2>
                  </div>
                  <p [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)" *ngIf="card?.description">{{card?.description}}</p>
                </div>
              </div>
              <div class="contact-sec container mt-2">
                <div class="contact-sec-wrap">
                  <div class="top-title"
                    *ngIf="card?.email || hasPhoneNumber(card)"
                    [style.color]="card?.digitalCardTextColor || card?.secondaryColor">
                    <h2>Contact Me</h2>
                  </div>
                  <div class="contact-bottom-sec">

                    <div class="contact-details mt-3" *ngIf="card?.email" [style.borderColor]="card?.secondaryColor">
                      <div class="contact-icon" [style.background]="card?.secondaryColor">
                        <i class="pi pi-envelope" style="font-size: 1.6rem" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"></i>
                      </div>
                      <div class="contact-content"
                        [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
                        >
                        <h4 class="mb-0">Email</h4>
                        <a [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)" href="mailto:{{card?.email}}">
                          {{card?.email}}
                        </a>
                      </div>
                    </div>

                    <div *ngIf="hasPhoneNumber(card)">
                        <div class="contact-details mt-3" [style.borderColor]="card?.secondaryColor" *ngFor="let phone of card?.phone">
                        <div class="contact-icon" [style.background]="card?.secondaryColor">
                            <i class="pi pi-phone" style="font-size: 1.6rem" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"></i>
                        </div>
                        <div class="contact-content">
                            <h4 class="mb-0">{{ phone?.type }}</h4>
                            <a [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)" href="tel:{{ phone.number }}">
                            {{ phone?.number }}
                            </a>
                        </div>
                        </div>
                    </div>

                    <ng-container *ngIf="hasLinkUrl(card)">
                        <h5 class="links-header" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">My Links</h5>
                        <div class="my-links" *ngFor="let link of card?.links">
                            <!-- If there is an imageUrl -->
                            <ng-container *ngIf="link.imageUrl; else originalTemplate">
                                <ng-container
                                    *ngTemplateOutlet="imageLinkTpl; context: { $implicit: link, card: card }">
                                </ng-container>
                            </ng-container>

                            <!-- Original layout if NO imageUrl -->
                            <ng-template #originalTemplate>
                                <a
                                    *ngIf="link?.url"
                                    [href]="link.url"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title="{{link?.name || link?.url}}">

                                    <div class="contact-details mt-3" *ngIf="link?.url" [style.borderColor]="card?.secondaryColor">
                                        <div class="contact-icon" [style.background]="card?.secondaryColor">
                                            <i class="pi pi-globe" style="font-size: 1.6rem" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"></i>
                                        </div>
                                        <div class="contact-content"
                                            [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
                                            >
                                            <h4 class="mb-0">{{ link?.name }}</h4>
                                            {{ link?.url ? (link.url.length > 35 ? (link.url | slice:0:35) + '...' : link.url) : '' }}
                                        </div>
                                    </div>
                                </a>
                            </ng-template>
                        </div>


                    </ng-container>

                    <gig-product-carousel
                        *ngIf="card?.productCarousel && card?.productCarousel.length > 0"
                        [dbCard]="card"
                        [productCarousel]="card?.productCarousel">
                    </gig-product-carousel>

                    <!-- Contact actions (reused) -->
                    <ng-container
                      *ngTemplateOutlet="contactActionsButtonTpl; context: { $implicit: card }"
                    ></ng-container>

                    <!-- QR Code (reused) -->
                    <ng-container
                      *ngTemplateOutlet="qrTpl; context: { $implicit: card }"
                    ></ng-container>

                    <!-- Powered by (reused) -->
                    <ng-container
                      *ngTemplateOutlet="poweredByTpl; context: { $implicit: card }"
                    ></ng-container>

                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #template10 let-card>
      <div class="main-template template10">
        <div class="card"
            [style.backgroundColor]="card?.backgroundImage ? 'transparent' : card?.primaryColor"
            [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">

            <div class="organization" *ngIf="card?.organization" [style.color]="card?.digitalCardTextColor || card?.secondaryColor">
                <h2>{{card?.organization}}</h2>
            </div>
            <div class="logo" *ngIf="card?.logo">
                <img
                    src="{{card?.logo || ''}}"
                    alt="Logo"
                    class="logo-img"
                />
            </div>
            <div class="profile-section">
                <div class="description" *ngIf="card?.description">
                    {{ card.description }}
                </div>

                <div class="profile-photo" [style.borderColor]="card?.secondaryColor">
                    <img *ngIf="card?.photo" [src]="card?.photo" alt="Profile photo">
                    <h2 *ngIf="!card?.photo" class="client-img">
                        {{ getInitials(card?.firstName, card?.lastName) }}
                    </h2>
                </div>
            </div>

            <div class="info">
                <h1 [style.color]="card?.digitalCardTextColor || card?.secondaryColor"
                    class="name" *ngIf="card?.firstName || card?.lastName">{{ card?.firstName }} <br/> {{ card?.lastName }}</h1>
                <h1 [style.color]="card?.digitalCardTextColor || card?.secondaryColor"
                    class="name" *ngIf="!card?.firstName && !card?.lastName">Your<br/> Name</h1>
                <p class="title" *ngIf="card?.title">
                    {{ card.title }}
                </p>

                <div class="contact">
                    <p *ngIf="card?.email">
                        <a href="mailto:{{card?.email}}"
                            [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
                        ><i class="pi pi-envelope"></i> {{ card.email }}</a>
                    </p>

                    <ng-container *ngIf="hasPhoneNumber(card)">
                        <p *ngFor="let phone of card?.phone" >
                            <a [href]="'tel:' + phone?.number" *ngIf="phone?.number"
                                [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">
                                <i class="pi pi-phone" *ngIf="phone?.number"></i> {{ phone.number }} <span class="label" *ngIf="phone?.type">({{ phone?.type }})</span>
                            </a>
                        </p>
                    </ng-container>

                </div>

                <ng-container *ngIf="hasLinkUrl(card)">
                    <h5 class="links-header" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">My Links</h5>
                    <div class="my-links" *ngFor="let link of card?.links">
                        <!-- If there is an imageUrl -->
                        <ng-container *ngIf="link.imageUrl; else originalTemplate">
                            <ng-container
                                *ngTemplateOutlet="imageLinkTpl; context: { $implicit: link, card: card }">
                            </ng-container>
                        </ng-container>

                        <!-- Original layout if NO imageUrl -->
                        <ng-template #originalTemplate>
                            <p>
                                <a href="{{ link?.url }}" target="_blank" *ngIf="link?.url"
                                    [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
                                    ><i class="pi pi-globe" *ngIf="link?.url"></i> {{ link.name }}</a>
                            </p>
                        </ng-template>
                    </div>
                </ng-container>

                <div class="social-icons" *ngIf="hasSocialUrl(card)">
                    <ng-container *ngFor="let social of card?.social">
                        <a *ngIf="social?.url && social?.name" [href]="social?.url" target="_blank" [style.color]="card?.secondaryColor">
                            <i class="pi pi-{{getSocialIcon(social?.name.toLowerCase())}}"></i>
                        </a>
                    </ng-container>
                </div>

                <hr class="divider" [style.backgroundColor]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"/>

                <gig-product-carousel
                    *ngIf="card?.productCarousel && card?.productCarousel.length > 0"
                    [dbCard]="card"
                    [productCarousel]="card?.productCarousel">
                </gig-product-carousel>

                <div class="contact-button">
                    <button
                        *ngIf="card?.vcf"
                        [style.background]="card?.secondaryColor"
                        [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)"
                        type="button"
                        (click)="downloadVCard()"
                        >
                        <i class="pi pi-user-plus" [style.color]="card?.buttonTextColor"></i> Save Contact
                    </button>
                    <!-- Lead-capture actions -->
                    <ng-container *ngIf="canAccessLeadCapture">

                        <!-- Default Add Contact (no custom form) -->
                        <button
                            *ngIf="!card?.customForm?.length"
                            [style.background]="card?.secondaryColor"
                            [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)"
                            type="button"
                            (click)="showDialogContactModal(card?.id)"
                        >
                            <i class="pi pi-user-plus" [style.color]="card?.buttonTextColor"></i> Add Contact
                        </button>

                        <!-- Custom Form Buttons -->
                        <button
                            *ngFor="let form of card?.customForm"
                            [style.background]="card?.secondaryColor"
                            [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)"
                            type="button"
                            (click)="showCustomDialogContactModal(card?.id, form)"
                        >
                            <i class="pi pi-align-justify" [style.color]="card?.buttonTextColor"></i> {{ form?.name }}
                        </button>

                    </ng-container>

                </div>

                <!-- QR Code (reused) -->
                <ng-container *ngTemplateOutlet="qrTpl; context: { $implicit: card }" ></ng-container>

                <!-- Powered by (reused) -->
                <ng-container *ngTemplateOutlet="poweredByTpl; context: { $implicit: card }" ></ng-container>
            </div>
        </div>

      </div>
    </ng-template>
    <ng-template #template11 let-card>
        <div class="main-template template11">
            <div
                class="card"
                [style.backgroundColor]="card?.backgroundImage ? 'transparent' : card?.primaryColor"
                [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
            >

            <div class="logo" *ngIf="card?.logo">
                <img
                    src="{{card?.logo || ''}}"
                    alt="Logo"
                    class="logo-img"
                />
            </div>

            <!-- Profile Section -->
            <div class="profile-section">
                <div class="profile-photo" [style.borderColor]="card?.secondaryColor">
                    <img *ngIf="card?.photo" [src]="card?.photo" alt="Profile photo" />
                    <h2 *ngIf="!card?.photo" class="client-img">
                        {{ getInitials(card?.firstName, card?.lastName) }}
                    </h2>
                </div>
            </div>

            <!-- Info Section -->
            <div class="info">
                <h1 class="name" *ngIf="card?.firstName || card?.lastName">{{ card?.firstName }} {{ card?.lastName }}</h1>
                <h1 class="name" *ngIf="!card?.firstName && !card?.lastName">Your Name</h1>
                <p class="title" *ngIf="card?.title">{{ card?.title }}</p>

                <div class="description" *ngIf="card?.description">
                    {{ card.description }}
                </div>
            </div>

            <!-- Contact Section -->
            <div class="contact">
                <!-- Org -->
                <div class="contact-box" *ngIf="card?.organization">
                    <a [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)">
                        <i class="pi pi-building" [style.color]="card?.buttonTextColor"></i>
                        <span>{{ card?.organization }}</span>
                    </a>
                </div>

                <!-- Phone -->
                <div class="contact-box" *ngIf="hasPhoneNumber(card)">
                    <ng-container *ngFor="let phone of card?.phone">
                        <a [href]="'tel:' + phone?.number" [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)">
                            <i class="pi pi-phone" [style.color]="card?.buttonTextColor"></i>
                            <span>{{ phone.number }}</span>
                        </a>
                    </ng-container>
                </div>

                <!-- Email -->
                <div class="contact-box" *ngIf="card?.email">
                    <a href="mailto:{{ card?.email }}" [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)">
                        <i class="pi pi-envelope" [style.color]="card?.buttonTextColor"></i>
                        <span>{{ card?.email }}</span>
                    </a>
                </div>

                <!-- Website / Links -->
                <ng-container *ngIf="hasLinkUrl(card)">
                    <h5 class="links-header" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">My Links</h5>
                    <div class="my-links contact-box" *ngFor="let link of card?.links">
                        <!-- If there is an imageUrl -->
                        <ng-container *ngIf="link.imageUrl; else originalTemplate">
                            <ng-container
                                *ngTemplateOutlet="imageLinkTpl; context: { $implicit: link, card: card }">
                            </ng-container>
                        </ng-container>

                        <!-- Original layout if NO imageUrl -->
                        <ng-template #originalTemplate>
                            <a href="{{ link?.url }}" target="_blank" [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)">
                                <i class="pi pi-globe"></i>
                                <span>{{ link?.name || link?.url }}</span>
                            </a>
                        </ng-template>
                    </div>
                </ng-container>

                <hr class="divider" [style.backgroundColor]="getContrastColor(card?.primaryColor)" />

                <div class="contact-box">
                     <gig-product-carousel
                        *ngIf="card?.productCarousel && card?.productCarousel.length > 0"
                        [dbCard]="card"
                        [productCarousel]="card?.productCarousel">
                    </gig-product-carousel>

                </div>

                <!-- Save Contact -->
                <div class="contact-box" *ngIf="card?.vcf">
                    <a href="javascript:void(0)" (click)="downloadVCard()" [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)">
                        <i class="pi pi-user-plus" [style.color]="card?.buttonTextColor"></i>
                        <span>Save Contact</span>
                    </a>
                </div>

                <!-- Add Contact -->
                <ng-container *ngIf="canAccessLeadCapture">

                    <!-- Default Add Contact (no custom form) -->
                    <div class="contact-box" *ngIf="!card?.customForm?.length">
                        <a
                            href="javascript:void(0)"
                            (click)="showDialogContactModal(card?.id)"
                            [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)"
                        >
                            <i class="pi pi-user-plus" [style.color]="card?.buttonTextColor"></i>
                            <span>Add Contact</span>
                        </a>
                    </div>

                    <!-- Custom Form Buttons -->
                    <ng-container *ngIf="card?.customForm?.length">
                        <div class="contact-box" *ngFor="let form of card?.customForm">
                        <a
                            href="javascript:void(0)"
                            (click)="showCustomDialogContactModal(card?.id, form)"
                            [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)"
                        >
                            <i class="pi pi-align-justify" [style.color]="card?.buttonTextColor"></i>
                            <span>{{ form?.name }}</span>
                        </a>
                        </div>
                    </ng-container>

                </ng-container>

            </div>

            <!-- QR Code -->
            <div class="qr-section">
                <ng-container *ngTemplateOutlet="qrTpl; context: { $implicit: card }"></ng-container>
            </div>

            <!-- Social Icons -->
            <div class="social-section" *ngIf="hasSocialUrl(card)">
                <p class="connect-text" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">Connect with me</p>
                <div class="social-icons">
                <ng-container *ngFor="let social of card?.social">
                    <a *ngIf="social?.url && social?.name" [href]="social?.url" target="_blank">
                        <i class="pi pi-{{ getSocialIcon(social?.name.toLowerCase()) }}"></i>
                    </a>
                </ng-container>
                </div>
            </div>

            <!-- Powered By -->
            <ng-container *ngTemplateOutlet="poweredByTpl; context: { $implicit: card }"></ng-container>
            </div>
        </div>
    </ng-template>
    <ng-template #template12 let-card>
        <div class="main-template template12">
            <div class="card"
                [style.background]="card?.backgroundImage ? 'transparent' : 'linear-gradient(170deg, ' + card?.primaryColor + ' 49.5%, ' + card?.secondaryColor + ' 50%)'"
                [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">
                <!-- Top Section (Logo + Profile Photo) -->
                <div class="top-section">
                    <div class="logo-container" *ngIf="card?.logo">
                    <img [src]="card?.logo" alt="Logo" class="logo" />
                    </div>
                    <div class="profile-photo" [style.borderColor]="card?.secondaryColor">
                    <img *ngIf="card?.photo" [src]="card?.photo" alt="Profile photo" />
                    <h2 *ngIf="!card?.photo" class="client-img">
                        {{ getInitials(card?.firstName, card?.lastName) }}
                    </h2>
                    </div>
                </div>

                <!-- Info Section -->
                <div class="info">
                    <h1 class="name">{{ card?.firstName }} {{ card?.lastName }}</h1>
                    <h2 class="title" *ngIf="card?.title">{{ card?.title }}</h2>
                    <p class="brand" *ngIf="card?.organization">{{ card?.organization }}</p>
                </div>

                <!-- Description -->
                <div [ngClass]="card?.backgroundImage ? 'description2' : 'description'" *ngIf="card?.description">
                    {{ card.description }}
                </div>

                <!-- Contact Section -->
                <div class="contact">
                    <div class="contact-box" *ngIf="hasPhoneNumber(card)" [style.borderColor]="card?.buttonTextColor || card?.primaryColor">
                        <ng-container *ngFor="let phone of card?.phone">
                            <a [href]="'tel:' + phone?.number" [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)">
                                <i class="pi pi-phone" [style.color]="card?.buttonTextColor"></i>
                                {{ phone?.number }}
                            </a>
                        </ng-container>
                    </div>

                    <div class="contact-box" *ngIf="card?.email" [style.borderColor]="card?.buttonTextColor || card?.primaryColor">
                        <a href="mailto:{{ card?.email }}" [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)">
                            <i class="pi pi-envelope" [style.color]="card?.buttonTextColor"></i>
                            {{ card?.email }}
                        </a>
                    </div>
                </div>

                <ng-container *ngIf="hasLinkUrl(card)">
                    <h5 class="links-header" [style.color]="card?.buttonTextColor || getContrastColor(card?.primaryColor)">My Links</h5>
                    <div class="my-links contact" *ngFor="let link of card?.links">
                        <!-- If there is an imageUrl -->
                        <ng-container *ngIf="link.imageUrl; else originalTemplate">
                            <ng-container
                                *ngTemplateOutlet="imageLinkTpl; context: { $implicit: link, card: card }">
                            </ng-container>
                        </ng-container>

                        <!-- Original layout if NO imageUrl -->
                        <ng-template #originalTemplate>
                            <div class="contact-box" [style.borderColor]="card?.buttonTextColor || card?.primaryColor">
                                <a href="{{ link?.url }}" target="_blank" [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)">
                                    <i class="pi pi-globe" [style.color]="card?.buttonTextColor"></i>
                                    {{ link?.name || link?.url }}
                                </a>
                            </div>
                        </ng-template>
                    </div>
                </ng-container>

                <!-- Divider -->
                <div class="divider"></div>

                <gig-product-carousel
                    *ngIf="card?.productCarousel && card?.productCarousel.length > 0"
                    [dbCard]="card"
                    [productCarousel]="card?.productCarousel">
                </gig-product-carousel>

                <div [ngClass]="card?.customForm?.length ? 'contact' : 'contact2'">
                    <!-- Save Contact -->
                    <div [ngClass]="card?.customForm?.length ? 'contact-box' : 'contact-box2'" *ngIf="card?.vcf">
                        <a
                            href="javascript:void(0)"
                            (click)="downloadVCard()"
                            [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)">
                            <i class="pi pi-user-plus" [style.color]="card?.buttonTextColor"></i>
                            <span>Save Contact</span>
                        </a>
                    </div>

                    <!-- Add Contact -->
                    <ng-container *ngIf="canAccessLeadCapture">
                        <ng-container *ngIf="card?.customForm?.length; else defaultContact">
                            <!-- Custom Form Buttons -->
                            <div class="contact-box mb-2" *ngFor="let form of card.customForm">
                                <a
                                    href="javascript:void(0)"
                                    (click)="showCustomDialogContactModal(card?.id, form)"
                                    [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)">
                                    <i class="pi pi-align-justify" [style.color]="card?.buttonTextColor"></i>
                                    <span>{{ form?.name }}</span>
                                </a>
                            </div>
                        </ng-container>
                        <ng-template #defaultContact>
                            <div class="contact-box2">
                                <a
                                    href="javascript:void(0)"
                                    (click)="showDialogContactModal(card?.id)"
                                    [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)">
                                    <i class="pi pi-user-plus" [style.color]="card?.buttonTextColor"></i>
                                    <span>Add Contact</span>
                                </a>
                            </div>
                        </ng-template>
                    </ng-container>
                </div>

                <!-- Social Section -->
                <div class="social-section" *ngIf="hasSocialUrl(card)">
                    <p class="connect-text" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)">Let's Connect</p>
                    <div class="social-icons">
                        <a *ngFor="let social of card?.social" [href]="social?.url" target="_blank" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)">
                            <i class="pi pi-{{ getSocialIcon(social?.name.toLowerCase()) }}"></i>
                        </a>
                    </div>
                </div>

                <!-- QR Code -->
                <div class="qr-section">
                    <ng-container *ngTemplateOutlet="qrTpl; context: { $implicit: card }"></ng-container>
                </div>

                <!-- Powered By -->
                <ng-container *ngTemplateOutlet="poweredByTpl; context: { $implicit: card }"></ng-container>
            </div>
        </div>
    </ng-template>
    <ng-template #template13 let-card>
        <div class="main-template template13">
            <div class="card"
                [style.background]="card?.backgroundImage ? 'transparent' : card?.primaryColor"
                [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">
                <!-- Curved Header -->
                <div class="header"
                    [style.background]="card?.secondaryColor"
                    [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)">
                    <div class="logo-container" *ngIf="card?.logo">
                        <img [src]="card?.logo" alt="Logo" class="logo" />
                    </div>
                    <!-- <div class="circle"></div> -->
                    <p class="brand" *ngIf="card?.organization">{{ card?.organization }}</p>
                </div>

                <!-- Info Section -->
                <div class="info">
                    <div class="photo-wrapper">
                        <div class="profile-photo"
                            [style.borderColor]="card?.primaryColor">
                            <img *ngIf="card?.photo" [src]="card?.photo" alt="Profile photo" />
                            <h2 *ngIf="!card?.photo" class="client-img">
                                {{ getInitials(card?.firstName, card?.lastName) }}
                            </h2>
                        </div>
                    </div>

                    <div class="text-info">
                        <h2 class="name" *ngIf="card?.firstName || card?.lastName">{{ card?.firstName }} {{ card?.lastName }}</h2>
                        <h2 class="name" *ngIf="!card?.firstName && !card?.lastName">Your Name</h2>
                        <p class="title" *ngIf="card?.title">{{ card?.title }}</p>
                    </div>
                </div>

                <div class="description" *ngIf="card?.description">
                    <p>{{ card?.description }}</p>
                </div>

                <!-- Contact Info -->
                <div class="contact">
                    <div class="contact-box" *ngIf="hasPhoneNumber(card)" >
                        <ng-container *ngFor="let phone of card?.phone">
                            <i class="pi pi-phone" [style.color]="card?.digitalCardTextColor || card?.secondaryColor"></i>
                            <a [href]="'tel:' + phone?.number" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">{{ phone?.number }}</a>
                        </ng-container>
                    </div>

                    <div class="contact-box" *ngIf="card?.email">
                        <i class="pi pi-envelope" [style.color]="card?.digitalCardTextColor || card?.secondaryColor"></i>
                        <a href="mailto:{{ card?.email }}" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">{{ card?.email }}</a>
                    </div>
                </div>

                <div class="contact">
                    <ng-container *ngIf="hasLinkUrl(card)">
                        <h5 class="links-header" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">My Links</h5>
                        <div class="my-links" *ngFor="let link of card?.links">
                            <!-- If there is an imageUrl -->
                            <ng-container *ngIf="link.imageUrl; else originalTemplate">
                                <ng-container
                                    *ngTemplateOutlet="imageLinkTpl; context: { $implicit: link, card: card }">
                                </ng-container>
                            </ng-container>

                            <!-- Original layout if NO imageUrl -->
                            <ng-template #originalTemplate>
                                <div class="contact-box">
                                    <i class="pi pi-globe" [style.color]="card?.digitalCardTextColor || card?.secondaryColor"></i>
                                    <a href="{{ link?.url }}" target="_blank" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">{{ link?.name || link?.url }}</a>
                                </div>
                            </ng-template>
                        </div>
                    </ng-container>
                </div>


                <!-- Social Media -->
                <div class="social-section" *ngIf="hasSocialUrl(card)">
                    <h4>Stay Connected</h4>
                    <div class="social-icons">
                        <a *ngFor="let social of card?.social" [href]="social?.url" target="_blank">
                            <i class="pi pi-{{ getSocialIcon(social?.name.toLowerCase()) }}" [style.color]="card?.digitalCardTextColor || card?.secondaryColor"></i>
                        </a>
                    </div>
                </div>

                <div class="contact">
                    <gig-product-carousel
                        *ngIf="card?.productCarousel && card?.productCarousel.length > 0"
                        [dbCard]="card"
                        [productCarousel]="card?.productCarousel">
                    </gig-product-carousel>
                </div>

                <!-- Contact actions (reused) -->
                <div class="text-center">
                    <ng-container
                        *ngTemplateOutlet="contactActionsButtonTpl; context: { $implicit: card }"
                    ></ng-container>
                </div>

                <!-- QR + Powered By -->
                <ng-container *ngTemplateOutlet="qrTpl; context: { $implicit: card }"></ng-container>

                <ng-container *ngTemplateOutlet="poweredByTpl; context: { $implicit: card }"></ng-container>
            </div>
        </div>
    </ng-template>
    <ng-template #template14 let-card>
        <div class="main-template template14">
            <div class="card"
                [style.background]="card?.backgroundImage
                ? 'transparent'
                : 'linear-gradient(to bottom, ' +
                    card?.primaryColor +
                    ' 0%, ' +
                    card?.secondaryColor +
                    ' 100%)'
                "
                [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
            >
                <!-- Header Accent -->
                <div class="header-accent"></div>

                <!-- Profile Section -->
                <div class="profile-section">
                    <div class="profile-photo" [style.borderColor]="card?.secondaryColor">
                        <img *ngIf="card?.photo" [src]="card?.photo" alt="Profile photo" />
                        <h2 *ngIf="!card?.photo" class="client-img">
                            {{ getInitials(card?.firstName, card?.lastName) }}
                        </h2>
                    </div>

                    <div class="name-section">
                        <h2 class="name">{{ card?.firstName || 'Your' }} {{ card?.lastName || 'Name' }}</h2>
                        <p class="title" *ngIf="card?.title">{{ card?.title }}</p>
                        <p class="brand" *ngIf="card?.organization">{{ card?.organization }}</p>
                    </div>
                </div>

                <!-- Description -->
                <div class="description" *ngIf="card?.description">
                    <p>{{ card?.description }}</p>
                </div>

                <!-- Contact Info -->
                <div class="contact-info">
                    <div class="contact-box" *ngIf="hasPhoneNumber(card)">
                        <ng-container *ngFor="let phone of card?.phone">
                            <i class="pi pi-phone"></i>
                            <a [href]="'tel:' + phone?.number" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">{{ phone?.number }}</a>
                        </ng-container>
                    </div>

                    <div class="contact-box" *ngIf="card?.email">
                        <i class="pi pi-envelope"></i>
                        <a href="mailto:{{ card?.email }}" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">{{ card?.email }}</a>
                    </div>
                </div>

                <ng-container *ngIf="hasLinkUrl(card)" class="contact-info">
                    <h5 class="links-header" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">My Links</h5>
                    <div class="my-links" *ngFor="let link of card?.links">
                        <!-- If there is an imageUrl -->
                        <ng-container *ngIf="link.imageUrl; else originalTemplate">
                            <ng-container
                                *ngTemplateOutlet="imageLinkTpl; context: { $implicit: link, card: card }">
                            </ng-container>
                        </ng-container>

                        <!-- Original layout if NO imageUrl -->
                        <ng-template #originalTemplate>
                            <div class="contact-box">
                                <i class="pi pi-globe"></i>
                                <a href="{{ link?.url }}" target="_blank" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">
                                    {{ link?.name || link?.url }}
                                </a>
                            </div>
                        </ng-template>
                    </div>
                </ng-container>


                <!-- Socials -->
                <div class="socials" *ngIf="hasSocialUrl(card)">
                    <div class="social-icons">
                        <a *ngFor="let social of card?.social" [href]="social?.url" target="_blank">
                            <i class="pi pi-{{ getSocialIcon(social?.name.toLowerCase()) }}"></i>
                        </a>
                    </div>
                </div>

                <!-- Company / Brand Logo -->
                <div class="logo-section" *ngIf="card?.logo">
                    <img [src]="card?.logo" alt="Company Logo" class="company-logo" />
                </div>

                <gig-product-carousel
                    *ngIf="card?.productCarousel && card?.productCarousel.length > 0"
                    [dbCard]="card"
                    [productCarousel]="card?.productCarousel">
                </gig-product-carousel>

                <!-- QR + Buttons + Powered By -->
                <ng-container *ngTemplateOutlet="contactActionsButtonTpl; context: { $implicit: card }"></ng-container>
                <ng-container *ngTemplateOutlet="qrTpl; context: { $implicit: card }"></ng-container>
                <ng-container *ngTemplateOutlet="poweredByTpl; context: { $implicit: card }"></ng-container>
            </div>
        </div>
    </ng-template>
    <ng-template #template15 let-card>
        <div class="main-template template15">
            <div class="card"
                [style.backgroundColor]="card?.backgroundImage ? 'transparent' : card?.primaryColor"
                [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">

            <!-- Header -->
            <div class="header">
                <div class="logo" *ngIf="card?.logo">
                <img [src]="card.logo" alt="Logo">
                </div>
                <div class="organization" *ngIf="card?.organization" [style.color]="card?.digitalCardTextColor || card?.secondaryColor">
                <h2>{{ card.organization }}</h2>
                </div>
            </div>

            <!-- Profile Section -->
            <div class="profile-section">
                <div class="profile-photo" [style.borderColor]="card?.secondaryColor">
                <img *ngIf="card?.photo" [src]="card.photo" alt="Profile photo">
                <h2 *ngIf="!card?.photo" class="client-img">
                    {{ getInitials(card?.firstName, card?.lastName) }}
                </h2>
                </div>
                <div class="description" *ngIf="card?.description">
                {{ card.description }}
                </div>
            </div>

            <!-- Name & Title -->
            <div class="info">
                <h1 class="name" [style.color]="card?.digitalCardTextColor || card?.secondaryColor">
                    {{ card?.firstName }} <br/> {{ card?.lastName }}
                </h1>
                <p class="title" *ngIf="card?.title">{{ card.title }}</p>

                <!-- Contact -->
                <div class="contact">
                    <p *ngIf="card?.email">
                        <a href="mailto:{{card?.email}}" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">
                        <i class="pi pi-envelope"></i> {{ card.email }}
                        </a>
                    </p>
                    <ng-container *ngIf="hasPhoneNumber(card)">
                        <p *ngFor="let phone of card?.phone">
                        <a [href]="'tel:' + phone?.number" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">
                            <i class="pi pi-phone"></i> {{ phone.number }} <span class="label" *ngIf="phone?.type">({{ phone?.type }})</span>
                        </a>
                        </p>
                    </ng-container>

                     <!-- Social -->
                    <div class="social-icons" *ngIf="hasSocialUrl(card)">
                        <ng-container *ngFor="let social of card?.social">
                            <a *ngIf="social?.url && social?.name" [href]="social.url" target="_blank" [style.color]="card?.secondaryColor">
                            <i class="pi pi-{{ getSocialIcon(social.name.toLowerCase()) }}"></i>
                            </a>
                        </ng-container>
                    </div>

                    <ng-container *ngIf="hasLinkUrl(card)">
                        <h5 class="links-header" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">My Links</h5>
                        <div class="my-links" *ngFor="let link of card?.links">
                            <!-- If there is an imageUrl -->
                            <ng-container *ngIf="link.imageUrl; else originalTemplate">
                                <ng-container
                                    *ngTemplateOutlet="imageLinkTpl; context: { $implicit: link, card: card }">
                                </ng-container>
                            </ng-container>

                            <!-- Original layout if NO imageUrl -->
                            <ng-template #originalTemplate>
                                <p>
                                    <a href="{{ link?.url }}" target="_blank" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">
                                        <i class="pi pi-globe"></i> {{ link.name }}
                                    </a>
                                </p>
                            </ng-template>
                        </div>
                    </ng-container>
                </div>



                <gig-product-carousel
                    *ngIf="card?.productCarousel && card?.productCarousel.length > 0"
                    [dbCard]="card"
                    [productCarousel]="card?.productCarousel">
                </gig-product-carousel>

                <!-- Buttons -->
                <div
                    class="contact-button"
                    [style.flex-wrap]="card?.customForm?.length > 1 ? 'wrap' : 'nowrap'"
                >
                    <!-- Save Contact -->
                    <button
                        *ngIf="card?.vcf"
                        (click)="downloadVCard()"
                        [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)"
                    >
                        <i class="pi pi-user-plus" [style.color]="card?.buttonTextColor"></i> Save Contact
                    </button>

                    <!-- Add Contact -->
                    <ng-container *ngIf="canAccessLeadCapture">

                        <!-- Default Add Contact (no custom form) -->
                        <button
                            *ngIf="!card?.customForm?.length"
                            (click)="showDialogContactModal(card?.id)"
                            [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)"
                            >
                            <i class="pi pi-user-plus" [style.color]="card?.buttonTextColor"></i> Add Contact
                        </button>

                        <!-- Custom Form Buttons -->
                        <button
                            *ngFor="let form of card?.customForm"
                            [style.color]="card?.buttonTextColor || getContrastColor(card?.secondaryColor)"
                            (click)="showCustomDialogContactModal(card?.id, form)"
                            >
                            <i class="pi pi-align-justify" [style.color]="card?.buttonTextColor"></i> {{ form?.name }}
                        </button>

                    </ng-container>
                </div>

                <!-- QR Code -->
                <ng-container *ngTemplateOutlet="qrTpl; context: { $implicit: card }"></ng-container>

                <!-- Powered by -->
                <ng-container *ngTemplateOutlet="poweredByTpl; context: { $implicit: card }"></ng-container>
            </div>
            </div>
        </div>
    </ng-template>
    <ng-template #template16 let-card>
        <div class="main-template template16">
            <div class="card"
                [style.backgroundColor]="card?.backgroundImage ? 'transparent' : card?.primaryColor"
                [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">

            <!-- Left Section (Photo + Social) -->
            <div class="left-section">
                <div class="profile-photo" [style.borderColor]="card?.primaryColor">
                    <img *ngIf="card?.photo" [src]="card.photo" alt="Profile photo">
                    <h2 *ngIf="!card?.photo" class="client-img">
                        {{ getInitials(card?.firstName, card?.lastName) }}
                    </h2>
                </div>

                <div class="social-icons" *ngIf="hasSocialUrl(card)">
                    <ng-container *ngFor="let social of card?.social">
                        <a *ngIf="social?.url && social?.name" [href]="social.url" target="_blank">
                        <i class="pi pi-{{ getSocialIcon(social.name.toLowerCase()) }}"></i>
                        </a>
                    </ng-container>
                </div>
                <div *ngIf="card?.organization">
                    <i
                        class="pi pi-building"
                        [style.color]="getContrastColor(card?.secondaryColor)"
                    ></i>
                    <span
                        [style.color]="getContrastColor(card?.secondaryColor)"
                    >{{card?.organization}}</span
                    >
              </div>

                <div class="logo" *ngIf="card?.logo">
                    <img [src]="card.logo" alt="Logo">
                </div>
            </div>

            <!-- Right Section (Info & Contact) -->
            <div class="right-section">
                <div>
                    <h1 class="name" [style.color]="card?.digitalCardTextColor || card?.secondaryColor">
                        {{ card?.firstName }} <br/> {{ card?.lastName }}
                    </h1>
                    <p class="title" *ngIf="card?.title">{{ card.title }}</p>
                    <p class="description" *ngIf="card?.description">{{ card.description }}</p>
                    </div>

                    <div class="contact">
                        <p *ngIf="card?.email">
                            <a href="mailto:{{card?.email}}" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">
                            <!-- <i class="pi pi-envelope"></i>  -->
                            {{ card.email }}
                            </a>
                        </p>
                    <ng-container *ngIf="hasPhoneNumber(card)">
                        <p *ngFor="let phone of card?.phone">
                            <a [href]="'tel:' + phone?.number" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">
                                <!-- <i class="pi pi-phone"></i>  -->
                                {{ phone.number }} <span class="label" *ngIf="phone?.type">({{ phone?.type }})</span>
                            </a>
                        </p>
                    </ng-container>

                    <ng-container *ngIf="hasLinkUrl(card)">
                        <h5 class="links-header" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">My Links</h5>
                        <div class="my-links" *ngFor="let link of card?.links">
                            <!-- If there is an imageUrl -->
                            <ng-container *ngIf="link.imageUrl; else originalTemplate">
                                <ng-container
                                    *ngTemplateOutlet="imageLinkTpl; context: { $implicit: link, card: card }">
                                </ng-container>
                            </ng-container>

                            <!-- Original layout if NO imageUrl -->
                            <ng-template #originalTemplate>
                                <p>
                                    <a href="{{ link?.url }}" target="_blank" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">
                                        <i class="pi pi-globe"></i> {{ link.name }}
                                    </a>
                                </p>
                            </ng-template>
                        </div>
                    </ng-container>
                </div>

                <hr class="divider"/>

                <gig-product-carousel
                    *ngIf="card?.productCarousel && card?.productCarousel.length > 0"
                    [dbCard]="card"
                    [productCarousel]="card?.productCarousel">
                </gig-product-carousel>

                <ng-container *ngTemplateOutlet="contactActionsButtonTpl; context: { $implicit: card }"></ng-container>
                <!-- QR Code -->
                <ng-container *ngTemplateOutlet="qrTpl; context: { $implicit: card }"></ng-container>
                <!-- Powered by -->
                <ng-container *ngTemplateOutlet="poweredByTpl; context: { $implicit: card }"></ng-container>
            </div>

            </div>
        </div>
    </ng-template>
    <ng-template #template17 let-card>
        <div class="main-template template17">
            <div class="card"
                [style.backgroundColor]="card?.backgroundImage ? 'transparent' : card?.primaryColor"
                [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">

                <!-- Top Header Background -->
                <div class="header-bg" [style.backgroundColor]="card?.secondaryColor">
                    <div class="logo" *ngIf="card?.logo">
                        <img [src]="card.logo" alt="Logo">
                    </div>
                </div>

                <!-- Floating Profile Section -->
                <div class="profile-section">
                    <div class="profile-photo" [style.borderColor]="card?.primaryColor">
                        <img *ngIf="card?.photo" [src]="card.photo" alt="Profile photo">
                        <h2 *ngIf="!card?.photo" class="client-img" [style.backgroundColor]="card?.secondaryColor" [style.color]="getContrastColor(card?.secondaryColor)">
                            {{ getInitials(card?.firstName, card?.lastName) }}
                        </h2>
                    </div>

                    <h1 class="name" [style.color]="card?.digitalCardTextColor || card?.secondaryColor">
                        {{ card?.firstName }} {{ card?.lastName }}
                    </h1>
                    <p class="title" *ngIf="card?.title">{{ card.title }}</p>

                    <div *ngIf="card?.organization" class="organization">
                        <i class="pi pi-building" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"></i>
                        <span>{{card?.organization}}</span>
                    </div>
                </div>

                <!-- Social Icons (Centered Row) -->
                <div class="social-icons" *ngIf="hasSocialUrl(card)">
                    <ng-container *ngFor="let social of card?.social">
                        <a *ngIf="social?.url && social?.name" [href]="social.url" target="_blank"
                        [style.backgroundColor]="card?.secondaryColor"
                        [style.color]="getContrastColor(card?.secondaryColor)">
                            <i class="pi pi-{{ getSocialIcon(social.name.toLowerCase()) }}"></i>
                        </a>
                    </ng-container>
                </div>

                <!-- Main Content & Contact -->
                <div class="content-section mt-3">
                    <p class="description" *ngIf="card?.description">{{ card.description }}</p>

                    <div class="contact-list">
                        <div class="contact-item" *ngIf="card?.email">
                            <div class="icon-box" [style.backgroundColor]="card?.secondaryColor + '20'">
                                <i class="pi pi-envelope" [style.color]="card?.secondaryColor"></i>
                            </div>
                            <a href="mailto:{{card?.email}}" [style.color]="card?.buttonTextColor">{{ card.email }}</a>
                        </div>

                        <ng-container *ngIf="hasPhoneNumber(card)">
                            <div class="contact-item" *ngFor="let phone of card?.phone">
                                <div class="icon-box" [style.backgroundColor]="card?.secondaryColor + '20'">
                                    <i class="pi pi-phone" [style.color]="card?.secondaryColor"></i>
                                </div>
                                <a [href]="'tel:' + phone?.number" [style.color]="card?.buttonTextColor">
                                    {{ phone.number }} <span class="label" *ngIf="phone?.type">({{ phone?.type }})</span>
                                </a>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="hasLinkUrl(card)">
                            <h5 class="links-header" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">My Links</h5>
                            <div class="my-links" *ngFor="let link of card?.links">
                                <!-- If there is an imageUrl -->
                                <ng-container *ngIf="link.imageUrl; else originalTemplate">
                                    <ng-container
                                        *ngTemplateOutlet="imageLinkTpl; context: { $implicit: link, card: card }">
                                    </ng-container>
                                </ng-container>

                                <!-- Original layout if NO imageUrl -->
                                <ng-template #originalTemplate>
                                    <div class="contact-item">
                                        <div class="icon-box" [style.backgroundColor]="card?.secondaryColor + '20'">
                                            <i class="pi pi-globe" [style.color]="card?.secondaryColor"></i>
                                        </div>
                                        <a href="{{ link?.url }}" target="_blank" [style.color]="card?.buttonTextColor">{{ link.name }}</a>
                                    </div>
                                </ng-template>
                            </div>
                        </ng-container>
                    </div>

                    <hr class="divider"/>

                    <gig-product-carousel
                        *ngIf="card?.productCarousel && card?.productCarousel.length > 0"
                        [dbCard]="card"
                        [productCarousel]="card?.productCarousel">
                    </gig-product-carousel>

                    <!-- Action Buttons -->
                    <ng-container *ngTemplateOutlet="contactActionsButtonTpl; context: { $implicit: card }"></ng-container>

                    <!-- QR Code -->
                    <ng-container *ngTemplateOutlet="qrTpl; context: { $implicit: card }"></ng-container>

                    <!-- Powered by -->
                    <ng-container *ngTemplateOutlet="poweredByTpl; context: { $implicit: card }"></ng-container>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #template18 let-card>
        <div class="main-template template18">
            <div class="card"
                [style.backgroundColor]="card?.backgroundImage ? 'transparent' : card?.primaryColor"
                [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">

                <!-- Top Banner with Logo -->
                <div class="top-banner" [style.background]="card?.secondaryColor">
                    <div class="logo" *ngIf="card?.logo">
                    <img [src]="card.logo" alt="Logo">
                    </div>
                </div>

                <!-- Floating Profile Photo -->
                <div class="profile-photo" [style.borderColor]="card?.secondaryColor">
                    <img *ngIf="card?.photo" [src]="card.photo" alt="Profile photo">
                    <h2 *ngIf="!card?.photo" class="client-img"
                        [style.backgroundColor]="card?.secondaryColor"
                        [style.color]="getContrastColor(card?.secondaryColor)">
                        {{ getInitials(card?.firstName, card?.lastName) }}
                    </h2>
                </div>

                <!-- Main Content -->
                <div class="content">
                    <h1 class="name">{{ card?.firstName }} {{ card?.lastName }}</h1>
                    <p class="title" *ngIf="card?.title">{{ card.title }}</p>

                    <div *ngIf="card?.organization" class="organization">
                        <i class="pi pi-building" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"></i>
                        <span>{{ card?.organization }}</span>
                    </div>

                    <p class="description" *ngIf="card?.description">{{ card.description }}</p>

                    <!-- Contacts -->
                    <div class="contact-list">
                        <div class="contact-item mb-2" *ngIf="card?.email">
                            <i class="pi pi-envelope"></i>
                            <a [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)" href="mailto:{{card?.email}}">{{ card.email }}</a>
                        </div>

                        <ng-container *ngIf="hasPhoneNumber(card)">
                            <div class="contact-item mb-2" *ngFor="let phone of card?.phone">
                                <i class="pi pi-phone"></i>
                                <a [href]="'tel:' + phone?.number" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">
                                    {{ phone.number }} <span class="label" *ngIf="phone?.type">({{ phone?.type }})</span>
                                </a>
                            </div>
                        </ng-container>
                    </div>

                    <ng-container *ngIf="hasLinkUrl(card)">
                        <h5 class="links-header" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">My Links</h5>
                        <div class="my-links" *ngFor="let link of card?.links">
                            <!-- If there is an imageUrl -->
                            <ng-container *ngIf="link.imageUrl; else originalTemplate">
                                <ng-container
                                    *ngTemplateOutlet="imageLinkTpl; context: { $implicit: link, card: card }">
                                </ng-container>
                            </ng-container>

                            <!-- Original layout if NO imageUrl -->
                            <ng-template #originalTemplate>
                                <div class="contact-list">
                                    <div class="contact-item">
                                        <i class="pi pi-globe"></i>
                                        <a [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)" href="{{ link?.url }}" target="_blank">{{ link.name }}</a>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </ng-container>

                    <gig-product-carousel
                        *ngIf="card?.productCarousel && card?.productCarousel.length > 0"
                        [dbCard]="card"
                        [productCarousel]="card?.productCarousel">
                    </gig-product-carousel>

                    <!-- Action Buttons -->
                    <ng-container *ngTemplateOutlet="contactActionsButtonTpl; context: { $implicit: card }"></ng-container>

                    <!-- QR Code -->
                    <ng-container *ngTemplateOutlet="qrTpl; context: { $implicit: card }"></ng-container>

                    <!-- Powered by -->
                    <ng-container *ngTemplateOutlet="poweredByTpl; context: { $implicit: card }"></ng-container>
                </div>

                <!-- Floating Social Icons at Bottom -->
                <div class="social-bottom" *ngIf="hasSocialUrl(card)">
                    <ng-container *ngFor="let social of card?.social">
                        <a *ngIf="social?.url && social?.name" [href]="social.url" target="_blank"
                            [style.backgroundColor]="card?.secondaryColor"
                            [style.color]="getContrastColor(card?.secondaryColor)">
                            <i class="pi pi-{{ getSocialIcon(social.name.toLowerCase()) }}"></i>
                        </a>
                    </ng-container>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #template19 let-card>
      <div class="main-template template19">
        <div
          class="card"
          [style.backgroundColor]="card?.backgroundImage ? 'transparent' : card?.primaryColor"
          [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
        >
          <!-- Header with gradient background -->
          <div class="header"></div>
          <!-- Main Content -->
          <div class="content">
            <!-- Profile Image -->
            <div
              class="profile-image"
              [style.backgroundColor]="card?.primaryColor"
              [style.borderColor]="card?.digitalCardTextColor || card?.primaryColor"
            >
              <img *ngIf="card?.photo" src="{{card?.photo}}" alt="Profile" />
              <div
                class="initials"
                *ngIf="!card?.photo"
                [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
              >
                <h2>{{ getInitials(card?.firstName, card?.lastName) }}</h2>
              </div>
            </div>
            <!-- Position/Role with better styling -->

            <div class="info-content">
              <div class="info-text">
                <h2 *ngIf="card?.firstName || card?.lastName">
                  {{ card?.firstName }} {{ card?.lastName }}
                </h2>
                <h2 *ngIf="!card?.firstName && !card?.lastName">Name</h2>
              </div>
            </div>

            <div
              class="position-role"
              [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
            >
              <p class="position">{{ card?.title || 'Professional' }}</p>
              <!-- <p *ngIf="card?.role" class="role">{{ card?.role }}</p> -->
            </div>
            <div class="description" *ngIf="card?.description">
              <span>{{card?.description}}</span>
            </div>

            <!-- Social Icons -->
            <div class="social-icons">
              <div *ngFor="let social of card?.social">
                <div *ngIf="social.url">
                  <a
                    [style.backgroundColor]="card?.secondaryColor"
                    [style.color]="card?.digitalCardTextColor || getContrastColor(card?.secondaryColor)"
                    [style.box-shadow]="'0 3px 8px ' + hexToRgba(card?.secondaryColor, 0.3)"
                    [href]="social.url"
                    target="_blank"
                    rel="noopener noreferrer"
                    [title]="social.name"
                  >
                    <i
                      class="pi pi-{{ getSocialIcon(social.name.toLowerCase()) }}"
                    ></i>
                  </a>
                </div>
              </div>
            </div>
            <!-- Contact Details -->
            <div
              class="contact-info"
              [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
            >
              <div class="contact-item" *ngIf="card?.organization">
                <span class="icon" [style.color]="card?.secondaryColor"
                  ><i class="pi pi-building"></i
                ></span>
                <span class="text">{{ card?.organization }}</span>
              </div>
              <div
                [class.contact-item]="hasPhoneNumber(card)"
                *ngFor="let phone of card?.phone">
                <span
                  *ngIf="phone.number"
                  class="icon"
                  [style.color]="card?.secondaryColor"
                  ><i class="pi pi-phone"></i
                ></span>
                <span class="text" *ngIf="phone.number">
                  <a
                    [href]="'tel:' + phone.number"
                    [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
                  >
                    Call {{ phone.number }}
                    <span class="label">({{ phone.type }})</span>
                  </a>
                </span>
              </div>
              <div class="contact-item" *ngIf="card?.email">
                <span class="icon" [style.color]="card?.secondaryColor"
                  ><i class="pi pi-envelope"></i
                ></span>
                <a
                  href="mailto:{{card?.email}}"
                  [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
                >
                  <span class="text">{{ card?.email }}</span>
                </a>
              </div>

                <ng-container *ngIf="hasLinkUrl(card)">
                    <h5 class="links-header" [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)">My Links</h5>
                    <div class="my-links" *ngFor="let link of card?.links">

                        <!-- If there is an imageUrl -->
                        <ng-container *ngIf="link.imageUrl; else originalTemplate">
                            <ng-container
                                *ngTemplateOutlet="imageLinkTpl; context: { $implicit: link, card: card }">
                            </ng-container>
                        </ng-container>

                        <!-- Original layout if NO imageUrl -->
                        <ng-template #originalTemplate>
                            <a
                                *ngIf="link.url"
                                [href]="link.url"
                                target="_blank"
                                rel="noopener noreferrer"
                                [style.color]="card?.digitalCardTextColor || getContrastColor(card?.primaryColor)"
                                class="link-card"
                            >
                                <span class="icon" [style.color]="card?.secondaryColor">
                                    <i class="pi pi-globe"></i>
                                </span>

                                <span class="text">
                                    <ng-container *ngIf="link.url.length > 50 && link.name; else showShortUrl2">
                                    {{ link.name }}
                                    </ng-container>
                                    <ng-template #showShortUrl2>
                                    {{ link.url }}
                                    </ng-template>
                                </span>
                            </a>
                            <div class="spacer mb-2"></div>
                        </ng-template>
                    </div>
                </ng-container>

            </div>

            <gig-product-carousel
                *ngIf="card?.productCarousel && card?.productCarousel.length > 0"
                [dbCard]="card"
                [productCarousel]="card?.productCarousel">
            </gig-product-carousel>

            <!-- Contact actions (reused) -->
            <ng-container
              *ngTemplateOutlet="contactActionsDivTpl; context: { $implicit: card }"
            ></ng-container>

            <!-- QR Code (reused) -->
            <ng-container
              *ngTemplateOutlet="qrTpl; context: { $implicit: card }"
            ></ng-container>
          </div>

          <!-- Powered by (reused) -->
          <ng-container
            *ngTemplateOutlet="poweredByTpl; context: { $implicit: card, extraClass: 'mt-0' }"
          ></ng-container>
        </div>
      </div>
        </ng-template>
    </ng-template>
</div>


<gig-confirmation-dialog
    [(visible)]="visibleContactModal"
    data-testid="public-card-contact-dialog"
    [title]="'Add Contact'"
    [width]="'40rem'"
    [hasProjectedContent]="true"
    >

    <div body>
        <form
            *ngIf="addContactFormValue"
            [formGroup]="addContactFormValue"
            [ngStyle]="{
            'opacity': addContactSubmitting ? 0.5 : 1,
            'pointer-events': addContactSubmitting ? 'none' : 'auto'
            }"
            class="p-fluid"
        >
            <div class="form-field">
            <label for="name" class="font-semibold">Name</label>
            <input
                pInputText
                id="name"
                data-testid="public-card-contact-name"
                autocomplete="off"
                formControlName="name"
                placeholder="Full name"
            />
            </div>

            <div class="form-field phone-group">
            <label class="font-semibold">Phone</label>
            <div class="flex flex-column md:flex-row gap-2 w-full">
                <input
                    pInputText
                    class="flex-1"
                    data-testid="public-card-contact-phone"
                autocomplete="off"
                formControlName="number"
                placeholder="Number"
                />
                <p-dropdown
                    class="flex-none md:w-7rem"
                    [options]="phoneTypes"
                    formControlName="type"
                    [id]="'phoneTypeAddContact'"
                    data-testid="public-card-contact-phone-type"
                    placeholder="Type">
                </p-dropdown>
            </div>
            </div>

            <div class="form-field">
                <label for="email" class="font-semibold">Email</label>
                <input
                    pInputText
                    id="email"
                    data-testid="public-card-contact-email"
                    autocomplete="off"
                    formControlName="email"
                    placeholder="Email"
                    type="email"
                />
            </div>

            <div class="form-field">
                <label for="organization" class="font-semibold">Organization</label>
                <input
                    pInputText
                    id="organization"
                    data-testid="public-card-contact-organization"
                    autocomplete="off"
                    formControlName="organization"
                    placeholder="Organization"
                />
            </div>

            <div class="form-field">
                <small *ngIf="isPhoneOrEmailTouchedAndHasValue()" class="text-red-500">
                    Please enter either a phone number or an email.
                </small>
            </div>


        </form>
    </div>
    <div class="flex justify-content-end gap-2">
        <gig-action-button
            [buttons]="actionButtons"
            (buttonClick)="onButtonClick($event)">
        </gig-action-button>
    </div>
</gig-confirmation-dialog>

<!-- Custom contact form -->
<p-dialog
  data-testid="public-card-custom-form-dialog"
  [header]="selectedCustomFormName"
  [modal]="true"
  [position]="'center'"
  [draggable]="false"
  [(visible)]="visibleCustomContactModal"
  [style]="{ width: '90vw', maxWidth: '40rem' }"
>
  <form
    *ngIf="customContactForm"
    [formGroup]="customContactForm"
    [ngStyle]="{
      'opacity': addContactSubmitting ? 0.5 : 1,
      'pointer-events': addContactSubmitting ? 'none' : 'auto'
    }"
    class="p-fluid"
  >

    <!-- Custom fields here -->

    <ng-container *ngFor="let fld of selectedCustomForm">
        <div class="form-field">

            <!-- Label -->
            <label [for]="fld.name" class="font-semibold">
            {{ fld.label }}
            <small *ngIf="fld.required" class="text-red-500">*</small>
            </label>

            <!-- Text / Email -->
            <ng-container *ngIf="fld.type !== 'textarea' && fld.type !== 'select' && fld.type !== 'dropdown'">
                <input
                    pInputText
                    [id]="fld.name"
                    [attr.data-testid]="'public-card-custom-field-' + fld.name"
                    autocomplete="off"
                    [formControlName]="fld.name"
                    [type]="fld.type"
                    [placeholder]="fld.placeholder"
                />
            </ng-container>

            <!-- Textarea -->
            <ng-container *ngIf="fld.type === 'textarea'">
                <textarea
                    pInputTextarea
                    [id]="fld.name"
                    [attr.data-testid]="'public-card-custom-field-' + fld.name"
                    [rows]="4"
                    [formControlName]="fld.name"
                    [placeholder]="fld.placeholder"
                ></textarea>
            </ng-container>

            <!-- Dropdown -->
            <ng-container *ngIf="fld.type === 'select' || fld.type === 'dropdown'">
                <p-dropdown
                    class="w-full"
                    [id]="fld.name"
                    [attr.data-testid]="'public-card-custom-field-' + fld.name"
                    [options]="fld.options"
                    [formControlName]="fld.name"
                    optionLabel="value"
                    optionValue="value"
                    [placeholder]="fld.placeholder || 'Select...'"
                    [showClear]="true"
                ></p-dropdown>
            </ng-container>

        </div>
    </ng-container>


    <!-- <div class="flex justify-content-end gap-2 mt-5">
      <p-button
        label="Cancel"
        severity="secondary"
        (click)="visibleCustomContactModal = false"
        type="button"
      ></p-button>

      <p-button
        [disabled]="customContactForm.invalid"
        label="Save"
        (click)="addCustomContactForm(customContactForm.value)"
      >
      </p-button>
    </div> -->

    <div class="flex justify-content-end gap-2">

        <gig-action-button
            [buttons]="[
                {
                    label: 'Cancel',
                    type: 'cancel',
                    icon: 'pi pi-times mr-1',
                    iconPos: 'left',
                    outlined: true,
                }
            ]"
            (click)="visibleCustomContactModal = false">
        </gig-action-button>

        <gig-action-button
            [buttons]="[
                {
                    id: 'addCutomFormButton',
                    label: 'Save',
                    icon: 'pi pi-check mr-1',
                    iconPos: 'left',
                    type: 'confirm',
                    disabled: customContactForm.invalid
                }
            ]"
            (click)="addCustomContactForm(customContactForm.value)">
        </gig-action-button>
    </div>

  </form>
</p-dialog>

<p-toast />
<p-confirmDialog></p-confirmDialog>
